/*
  si-fys2.js · Find Your Service Fassung 2 (Section si-fys2, Vorlage page.fys2), 10.10.2026
  Regelwerk: interior-design-crm/FIND-YOUR-SERVICE-PLAN.md, Abschnitt „Fassung 2 nach Sophias Feedback“.
  Basis: si-fys.js Fassung 1 (Warenkorb, Upload, Termine, Tracking unverändert übernommen).

  Ablauf (Fassung 5b, 11.10.2026): Start (A Projekt / B orientieren → 3 Themen) → Räume → Größe → Möbelplatzierung → Situation
          → [nur bei „noch nicht fertig“: Was würde Dir am meisten helfen?] → Details (2D: wie viel neu, 3D: Shoppingliste) → Zwischenergebnis
          Situation „eigene Ideen“ → Paket 1; „Maximale aus Raum und Bestand“ / „bei null“ → Paket 3.
          → Teil 2: Küche → Situation → welche Möbel bleiben → Timing → Nachricht → Kontakt.
  Ergebnis: Paketvorschlag (falls es einen gibt) und darunter immer der Kontaktbereich.
  Individuelles Angebot bei Neubau/Umbau, Büro, „Andere Kombination“, ab 4 Räumen oder einem Raum über 40 m².
  Seit 25.10.2026 kommen Grundriss, Situation und Hilfe auch dort (außer Neubau/Umbau und reinem Büro), damit das Angebot die Infos hat;
  danach geht es ohne Empfehlungsseite direkt zu den Zusatzfragen, der Grund fürs eigene Angebot steht im Kontakt-Schritt.

  Personenbezogene Daten entstehen erst beim Absenden des Kontaktbereichs. Die Sprachnachricht bleibt bis dahin
  im Browser und wird erst beim Absenden hochgeladen.
*/
(function () {
  'use strict';

  var root = document.querySelector('[data-si-fys]');
  if (!root || root.dataset.siFysBereit) return;
  root.dataset.siFysBereit = '1';
  var CFG = JSON.parse(root.querySelector('[data-si-fys-daten]').textContent);
  // Testmodus (25.10.2026, Vorlage page.fys-test): kein Tracking, kein Zähler, nichts ans CRM, nichts in den Warenkorb.
  // Was sonst gesendet würde, steht in der Browser-Konsole („[FYS-Test]“).
  var TEST = CFG.test === true;
  function testLog(was, daten) { try { console.info('[FYS-Test] ' + was, daten || ''); } catch (e) {} }

  // Team-Gerät (29.10.2026): Einmal /pages/find-your-service?team=1 öffnen, dann zählen Besuche dieses Browsers
  // weder im eigenen Trichter (Wochenbericht) noch in GA4/Ads. Anfragen und Warenkorb laufen normal, damit Ihr
  // den ganzen Weg testen könnt. Aufheben mit ?team=0. Gespeichert nur im Browser des Teams (localStorage si_team).
  var TEAM = (function () {
    try {
      var q = new URLSearchParams(location.search).get('team');
      if (q === '1') localStorage.setItem('si_team', '1');
      if (q === '0') localStorage.removeItem('si_team');
      return localStorage.getItem('si_team') === '1';
    } catch (e) { return false; }
  })();
  if (TEAM && !TEST) {
    try {
      var teamHinweis = document.createElement('div');
      teamHinweis.textContent = 'Team-Gerät · zählt nicht im Trichter';
      teamHinweis.setAttribute('style', 'position:fixed;left:8px;bottom:8px;z-index:9999;background:#364242;color:#fff;font:12px/1.4 sans-serif;padding:4px 8px;opacity:.85;pointer-events:none');
      document.body.appendChild(teamHinweis);
    } catch (e) {}
  }

  var FORM_VERSION = '2026-10-v9-shop'; // v9 (25.10.2026): Empfehlung am Schluss mit Buchen, Mail oder Erstgespräch (Termine); v8 (25.10.2026): Grundriss/Situation/Hilfe auch im individuellen Angebot; v7 (23.10.2026): PLZ freiwillig
  // Fassung 6 (Tobias, 13.10.2026): Situation neu, Details weg, Teil 2 nur noch Küche (falls nötig), Timing „bis wann“, Nachricht (Pflicht: Text oder Sprache), Kontakt
  // Fassung 4 (Tobias, 10.10.2026 spät): Teil 1 bis zum Zwischenergebnis, Teil 2 für die persönliche Empfehlung per Mail
  // Fassung 5 (Tobias, 11.10.2026): Möbelplatzierung und Bestand vor „Was würde Dir am meisten helfen?“,
  // Details je Paket (2D: wie viel neu, 3D: Shoppingliste), welche Möbel bleiben erst in Teil 2 („moebel“)
  // Fassung 5b (11.10.2026 nachts): „Hast Du schon Möbel?“ ersetzt durch „Welche Situation trifft am besten auf Dich zu?“ (lage)
  // Seit 25.10.2026 (Tobias): alle Fragen zuerst, die Empfehlung ganz am Schluss; Kontakt sitzt im Abschluss (kein eigener Schritt)
  var SCHRITTE = ['raeume', 'kueche', 'groesse', 'platzierung', 'lage', 'wunsch', 'timing', 'nachricht', 'vorschlag'];
  var TEIL1 = SCHRITTE; // eine durchgehende Schrittleiste (25.10.2026)
  var LEISTE_NAME = { raeume: 'Räume', groesse: 'Größe', platzierung: 'Grundriss', lage: 'Situation', wunsch: 'Hilfe', vorschlag: 'Empfehlung', kueche: 'Küche', timing: 'Timing', nachricht: 'Nachricht', kontakt: 'Kontakt' };
  // Info-Teil vor dem Fragebogen (Fassung 2.1): Start → Orientieren → drei Themen
  var INFO = ['start', 'orientieren', 'thema-kennen', 'thema-leistungen', 'thema-passt'];
  function istInfo(s) { return INFO.indexOf(s) >= 0; }

  var ICON = {
    wohnzimmer: '<path d="M5 20v-8a3 3 0 0 1 6 0v2h18v-2a3 3 0 0 1 6 0v8M5 20h30v6H5zM9 26v4M31 26v4"/>',
    esszimmer: '<path d="M8 16h24M12 16v14M28 16v14M6 10v20M34 10v20M6 20h4M30 20h4"/>',
    wohness: '<path d="M3 24v-5a2.5 2.5 0 0 1 5 0v1h10v-1a2.5 2.5 0 0 1 5 0v5M3 24h20v4H3zM26 18h11M28 18v12M35 18v12"/>',
    kueche: '<path d="M6 14h28M8 14v16h24V14M12 10a3 3 0 0 1 6 0M22 10a3 3 0 0 1 6 0M14 20h12"/>',
    schlafzimmer: '<path d="M4 28V10M4 22h32v6M36 28v-6a4 4 0 0 0-4-4H16v4M8 18h6a2 2 0 0 1 2 2v2H8z"/>',
    kinderzimmer: '<path d="M8 30V18l6-6 6 6v12zM20 30h12V20h-12M24 24h4"/>',
    homeoffice: '<path d="M6 18h28M10 18v12M30 18v12M13 10h14v8H13zM18 22h4"/>',
    flur: '<path d="M10 32V8h20v24M16 20h1M6 32h28"/>',
    bad: '<path d="M6 20h28v4a6 6 0 0 1-6 6H12a6 6 0 0 1-6-6zM10 20V11a3 3 0 0 1 6 0M12 30l-2 3M28 30l2 3"/>',
    buero: '<path d="M6 14h28v16H6zM15 14v-4h10v4M6 21h28"/>',
    kuecheess: '<path d="M4 14h16M6 14v15h12V14M9 10a2.5 2.5 0 0 1 5 0M23 20h14M25 20v10M35 20v10"/>',
    wohnkueche: '<path d="M2 27v-4a2 2 0 0 1 4 0v1h8v-1a2 2 0 0 1 4 0v4M2 27h16v3H2zM21 22h8M22 22v8M28 22v8M31 12h7M32 12v18h5V12"/>',
    anderes: '<path d="M20 10v20M10 20h20"/>',
    kombi: '<path d="M5 9h13v13H5zM22 18h13v13H22zM20 9v6M17 12h6"/>',
    neubau: '<path d="M5 20 20 8l15 12M9 17v15h22V17M17 32v-8h6v8M27 6v6"/>'
  };
  // IDs wie in si-paket.js und im CRM (FYS_RAUM), damit Produktseiten und Akte die Auswahl verstehen.
  // Neue Namen seit 10.10.2026: Arbeitszimmer, Wohn- & Esszimmer, Esszimmer mit Küche, Wohn- & Essküche.
  var RAEUME = [
    { id: 'wohnzimmer', label: 'Wohnzimmer', gruppe: 'zimmer' },
    { id: 'esszimmer', label: 'Esszimmer', gruppe: 'zimmer' },
    { id: 'schlafzimmer', label: 'Schlafzimmer', gruppe: 'zimmer' },
    { id: 'flur', label: 'Flur', gruppe: 'zimmer' },
    { id: 'homeoffice', label: 'Arbeitszimmer', gruppe: 'zimmer' },
    { id: 'kinderzimmer', label: 'Kinderzimmer', gruppe: 'zimmer' },
    { id: 'kueche', label: 'Küche', gruppe: 'zimmer' },
    { id: 'bad', label: 'Bad', gruppe: 'zimmer' },
    { id: 'anderes', label: 'Anderer Raum', gruppe: 'zimmer', text: 'Welcher Raum?', platz: 'z. B. Gästezimmer, Ankleide' },
    { id: 'wohness', label: 'Wohn- & Esszimmer', gruppe: 'offen' },
    { id: 'kuecheess', label: 'Esszimmer mit Küche', gruppe: 'offen' },
    { id: 'wohnkueche', label: 'Wohn- & Essküche', gruppe: 'offen' },
    { id: 'kombi', label: 'Andere Kombination', gruppe: 'offen', text: 'Welche Bereiche gehören dazu?', platz: 'z. B. Wohnzimmer mit Arbeitsecke' },
    { id: 'buero', label: 'Büro, Praxis & Gewerbe', gruppe: 'gewerbe' },
    { id: 'neubau', label: 'Neubau, Umbau oder Renovierung', gruppe: 'bau' }
  ];
  var GRUPPEN = [['zimmer', 'Einzelne Räume'], ['offen', 'Kombinierte Räume'], ['gewerbe', 'Geschäftlich'], ['bau', 'Anderes Vorhaben']];

  // Zusatzfrage für kombinierte Räume mit Küche (10.10.2026): a/b → Paket 3, c → individuelles Angebot, d → Erstgespräch
  var KUECHE_RAEUME = ['kuecheess', 'wohnkueche'];
  var KUECHE = [
    { id: 'a', titel: 'Die Küche ist bereits vorhanden und soll in das Raumkonzept integriert werden' },
    { id: 'b', titel: 'Ich plane eine neue Küche und möchte sie im Raumkonzept sehen' },
    { id: 'c', titel: 'Ich brauche Unterstützung bei der konkreten Küchenplanung' },
    { id: 'd', titel: 'Ich bin mir noch nicht sicher' }
  ];

  // Fassung 3 (Sophia/Tobias, 10.10.2026 abends): zwei Fragen statt der alten Hilfe-Frage.
  // 1) „Was beschäftigt Dich aktuell?“ (Mehrfachauswahl) → mögliche Pakete
  // Teil 2 „Was beschäftigt Dich?“ und „Welche Möbel bleiben?“ entfallen seit 13.10.2026 (Tobias)
  // 2) „Was würde Dir am meisten helfen?“ → entscheidet, wenn es zu Frage 1 passt; sonst Erstgespräch.
  //    „unsicher“ → persönliche Empfehlung von Sophia (Teil 2).
  //    Pakete als drei Bildkarten nebeneinander, „unsicher“ als Zeile darunter mit Sophia als rundem Avatar (Tobias, 11.10.2026).
  var BILD = 'https://cdn.shopify.com/s/files/1/0646/4883/9419/files/';
  var WUNSCH = [
    { id: 'gespraech', paket: 'beratung', titel: 'Eigene Ideen und Fragen direkt per Video-Call besprechen', klein: '', bild: BILD + '230901_Besichtigungonline_1.png?v=1715348196&width=600' },
    { id: 'zweid', paket: 'styling', titel: 'Ein 2D-Visionboard mit ergänzenden Produkten und Wandfarben, passend zu meinem Bestand', klein: '', bild: BILD + 'FYS-Visionboard.jpg?v=1791652821&width=600' },
    { id: 'dreid', paket: 'concept', titel: 'Virtuelle 3D-Roomtour, um Möglichkeiten zu testen und das Designkonzept vor der Umsetzung genau zu sehen', klein: '', bild: BILD + 'FYS-RenderingBild.jpg?v=1791652810&width=600' },
    { id: 'unsicher', paket: '', titel: 'Ich bin mir unsicher', klein: 'Völlig nachvollziehbar! Dann brauchen wir noch ein paar mehr Infos von Dir und Sophia gibt Dir eine persönliche Empfehlung.', avatar: CFG.sophiaBild || BILD + 'Sophia_PopArt.png?v=1772035954&width=160' }
  ];
  var ALLE = '_alle';
  // Vor „Was würde Dir am meisten helfen?“, einmal für das ganze Projekt (Tobias, 11.10.2026, wie Typeform Frage 13)
  var PLATZIERUNG = [['ja', 'Ja, bitte erstellt mir Grundrissvarianten'], ['nein', 'Nein, brauche ich nicht'], ['gemeinsam', 'Lasst uns das gemeinsam besprechen']];
  // Situation (Tobias 13.10.2026): drei Antworten ohne Erklärzeile, ohne Wirkung aufs Paket; das Paket entscheidet immer „Was würde Dir am meisten helfen?“.
  // Die Situation färbt nur die Begründung in der Empfehlung. Alte IDs (ideen, fertig, bestand, null) kennen Edge Function und CRM weiter.
  var LAGE = [
    ['videocall', 'Mir reicht ein Video-Call mit einem Profi, um meine eigenen Ideen zu besprechen'],
    ['ergaenzen', 'Mir reichen ein paar ergänzende Möbelstücke und Empfehlungen zu Wandfarben & Deko'],
    ['lost', 'Ich bin komplett lost, auf jeder Ebene']
  ];
  // Details (Menge, Shoppingliste) entfallen seit 13.10.2026: die Empfehlung startet mit „bis 7“ bzw. „ohne Shoppingliste“, umstellbar per Schalter (Tobias)
  // Timing (eigener Reiter): Projektstand und Wunschtermin, für alle Räume gemeinsam
  // Timing seit 25.10.2026 (Tobias): wann es losgehen soll; „dringend“ nur mit Begründung
  var START = [['dringend', 'Es ist super dringend, weil …'], ['2wochen', 'Innerhalb der nächsten 2 Wochen'], ['spaeter', 'Später, ich bin zeitlich flexibel']]; // Schlüssel, wenn die Antworten für alle Räume gelten

  var PAKETE = {
    beratung: { nr: 'Paket 1', name: 'Interior Beratungsstunde', artikel: 'die', kurz: 'Interior Beratungsstunde', was: 'Online mit einer unserer Designer*innen: Wir analysieren Deinen Raum und zeigen Dir sofort umsetzbare Lösungen.' },
    styling: { nr: 'Paket 2', name: 'Styling Upgrade in 2D', artikel: 'das', kurz: 'Styling Upgrade', was: 'Wir ergänzen Deinen Bestand gezielt mit neuen Produkten: 2D-Visionboard und Shoppingliste inklusive.' },
    concept: { nr: 'Paket 3', name: 'Interior Design Concept in 3D', artikel: 'das', kurz: 'Interior Design Concept', was: 'Komplettes Konzept mit maßgetreuer Grundrissplanung und interaktiver 3D-Roomtour. So erlebst Du Dein neues Zuhause, bevor Du etwas kaufst.' }
  };
  var OPTION_NAME = { bis7: 'bis 7 neue Produkte', mehr7: 'mehr als 7 neue Produkte', ohne: 'ohne Shoppingliste', mit: 'inkl. Shoppingliste' };
  var TYP = { einzel: 'Einzelraum', kuechebad: 'Küche oder Bad', offen2: 'Kombinierter Raum, 2 Bereiche', kuecheess: 'Esszimmer mit Küche', wohnkueche: 'Wohn- & Essküche, 3 Bereiche' };
  var STUNDEN = { einzel: 'ca. 1 Std.', kuechebad: 'ca. 1 Std.', offen2: 'ca. 1,5 Std.', kuecheess: 'ca. 1,5 Std.', wohnkueche: 'ca. 2,5 Std.' };
  var LISTE_TEXT = { einzel: 'Shoppingliste', offen2: 'Shoppingliste', kuecheess: 'Shoppingliste für den Essplatz', wohnkueche: 'Shoppingliste für Wohnen + Essen' };
  // Wert der Shopify-Option „Raum“ je Preisstufe (wie si-paket.js), erster vorhandener gewinnt.
  // 23.10.2026: Küche/Bad-Varianten gelöscht (die Räume gehen immer zum individuellen Angebot).
  // Variante seit 23.10.2026 „Kombinierter Raum - 2 Bereiche“ (vorher „Offener Raum - 2 Bereiche“).
  var OFFEN2 = ['Kombinierter Raum - 2 Bereiche'];
  var RAUM_WERT = {
    beratung: { einzel: ['Einzelraum'], offen2: OFFEN2 },
    styling: { einzel: ['Einzelraum'], offen2: OFFEN2 },
    concept: { einzel: ['Einzelraum'], offen2: OFFEN2 }
  };
  var AB_RAEUMEN_INDIVIDUELL = 4; // „mehr als 3 Räume“ (10.10.2026); kombinierte Räume zählen als einer
  var GROESSEN = [['bis15', 'bis 15 m²'], ['15-25', '15–25 m²'], ['25-40', '25–40 m²'], ['ueber40', 'über 40 m²'], ['unbekannt', 'Weiß ich nicht']];
  var GROSSER_RAUM = 'ueber40';
  var HERKUNFT = ['Google', 'Instagram/Facebook', 'Houzz', 'KI-Suche (ChatGPT & Co.)', 'Empfehlung', 'Andere'];
  // Wer von Paket- oder Produktseiten kommt, kennt die Pakete schon und startet direkt mit den Fragen
  var DIREKT = /^(paketkarten|.+_karte|.+_cta)$/;

  // ================= Zustand =================
  var antworten = { weg: '', raeume: [], raumText: {}, kueche: {}, groessen: {}, platzierung: {}, lage: {}, start: '', dringendGrund: '', fuerAlle: true, wunsch: {}, nachricht: '', vorname: '', nachname: '', email: '', plz: '', herkunft: '' };
  var dateien = []; // { name, datei, pfad, status: 'vorbereiten' | 'bereit' | 'fertig' | 'fehler' | 'weg' }
  var aktuell = 'start';
  var gestartet = false, abgeschickt = false;
  var schrittSeit = Date.now();
  var gesehen = {};
  var raumWahl = {};
  var $ = function (id) { return document.getElementById('fys-' + id); };
  var weiterBtn = $('weiter'), zurueckBtn = $('zurueck');
  var HAKEN = '<span class="haken" aria-hidden="true"><svg viewBox="0 0 24 24"><path d="M5 12l5 5 9-10"/></svg></span>';
  var KAESTCHEN = '<span class="kaestchen" aria-hidden="true"><svg viewBox="0 0 24 24"><path d="M5 12l5 5 9-10"/></svg></span>';
  // Antworten, die nicht von selbst weitergehen, bekommen statt → einen Auswahlpunkt (Test 25.10.2026, A12)
  var PUNKT = '<span class="punkt" aria-hidden="true"></span>', PFEIL = '<span class="pfeil" aria-hidden="true">→</span>';
  function reduziert() { return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches; }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function euro(cent) { return (Math.round(cent) / 100).toLocaleString('de-DE', { maximumFractionDigits: 2 }) + ' €'; }
  function arr(sel) { return Array.prototype.slice.call(sel); }

  // Kennung verknüpft Antworten, Upload-Ordner, Warenkorb und Anfrage im CRM
  function neueId() {
    var z = 'abcdefghijklmnopqrstuvwxyz0123456789', s = '', a = new Uint8Array(16);
    (window.crypto || window.msCrypto).getRandomValues(a);
    for (var i = 0; i < a.length; i++) s += z[a[i] % z.length];
    return 'fys-' + s;
  }
  var fysId = neueId();
  // Eigene Kennung nur für den Zähler (Wochenbericht, 14.10.2026): liegt nur im Arbeitsspeicher, ist nicht die fysId
  var besuch = 'b-' + neueId().slice(4), fortgesetzt = false;

  // Herkunft: Kanal und Klick-ID nur mit Einwilligung, geliefert von snippets/si-herkunft.liquid (window.siHerkunft).
  // Der Einstieg (?von=…) ist unser eigener Link-Parameter und wird nur aus der Adresse gelesen, nicht gespeichert.
  var einstieg = (new URLSearchParams(location.search).get('von') || '').replace(/[^a-z0-9_-]/gi, '').slice(0, 40);
  var mitStart = !DIREKT.test(einstieg);
  function quelle() {
    var h = window.siHerkunft || {};
    return { source: h.source || '', gclid: h.gclid || '', einstieg: einstieg };
  }

  // ================= Produkte und Preise (aus Shopify) =================
  var P = {};
  Object.keys(PAKETE).forEach(function (k) {
    var d = (CFG.pakete || {})[k] || {}, opt = d.optionen || [], i2 = opt.indexOf(k === 'concept' ? 'Shoppingliste' : 'Neue Produkte'), werte2 = [];
    (d.varianten || []).forEach(function (v) { if (i2 >= 0 && werte2.indexOf(v.options[i2]) < 0) werte2.push(v.options[i2]); });
    P[k] = { url: d.url || '#', bild: d.bild || '', varianten: (d.varianten || []).filter(function (v) { return v.available !== false; }), iRaum: opt.indexOf('Raum'), i2: i2, werte2: werte2 };
  });
  function wert2(paket, o) {
    var w = P[paket].werte2, f = function (re) { return w.filter(function (x) { return re.test(x); })[0]; };
    if (o === 'mit') return f(/^(mit|inkl)/i);
    if (o === 'ohne') return f(/^ohne/i);
    if (o === 'mehr7') return f(/mehr/i);
    if (o === 'bis7') return f(/bis/i) || w[0];
    return undefined;
  }
  function variante(paket, stufe, o) {
    var p = P[paket], raum = RAUM_WERT[paket][stufe], w = p.i2 >= 0 ? wert2(paket, o) : undefined;
    if (!raum || p.iRaum < 0) return null;
    for (var k = 0; k < raum.length; k++) {
      var treffer = p.varianten.filter(function (v) { return v.options[p.iRaum] === raum[k] && (p.i2 < 0 || v.options[p.i2] === w); })[0];
      if (treffer) return treffer;
    }
    return null;
  }

  // ================= Räume und Regeln =================
  function raum(id) { return RAEUME.filter(function (x) { return x.id === id; })[0]; }
  function raumLabel(id) {
    var t = (antworten.raumText[id] || '').trim();
    return raum(id).label + (t && id === 'anderes' ? ' (' + t + ')' : '');
  }
  function hat(id) { return antworten.raeume.indexOf(id) >= 0; }
  function istNeubau() { return hat('neubau'); }
  // Räume, die wir als Wohnraum planen (ohne Büro und Neubau); „Andere Kombination“ zählt als ein Raum
  function wohnraeume() { return antworten.raeume.filter(function (r) { return r !== 'buero' && r !== 'neubau'; }); }
  function anzahlRaeume() { return wohnraeume().length; }
  function preisstufe(id) { return { kueche: 'kuechebad', bad: 'kuechebad', wohness: 'offen2', kuecheess: 'kuecheess', wohnkueche: 'wohnkueche' }[id] || 'einzel'; }
  function istKuecheBad(id) { return preisstufe(id) === 'kuechebad'; }
  function nurGewerbe() { return antworten.raeume.length > 0 && wohnraeume().length === 0 && !istNeubau(); }
  function kuecheRaeume() { return wohnraeume().filter(function (r) { return KUECHE_RAEUME.indexOf(r) >= 0; }); }
  function kuecheAntwort(wert) { return kuecheRaeume().some(function (r) { return antworten.kueche[r] === wert; }); }
  // Immer individuelles Angebot, schon bevor die Hilfe-Fragen kommen (Regeln 10.10.2026)
  var IMMER_INDIVIDUELL = ['neubau', 'buero', 'kombi', 'anderes', 'kueche', 'bad', 'kuecheess', 'wohnkueche'];
  function individuellFest() { return IMMER_INDIVIDUELL.some(hat) || anzahlRaeume() >= AB_RAEUMEN_INDIVIDUELL || grosseRaeume().length > 0; }
  function hilfeFragen() { return anzahlRaeume() > 0 && !individuellFest(); }
  // Grundriss, Situation und Hilfe auch im individuellen Angebot abfragen (Tobias 25.10.2026: sonst fehlen die Infos fürs Angebot).
  // Nicht bei Neubau/Umbau und reinem Büro/Gewerbe. Das Ergebnis bleibt dort „Individuelles Angebot“ (empfehlung() prüft zuerst die festen Fälle).
  function fragenZeigen() { return anzahlRaeume() > 0 && !istNeubau(); }
  function gemeinsam() { return antworten.fuerAlle || wohnraeume().length < 2; }
  function schluessel(r) { return gemeinsam() ? ALLE : r; }
  // Grundriss und Situation seit 13.10.2026 wie Situation/Wunsch je Schlüssel (ALLE oder Raum), gleicher Schalter „Gilt für alle Räume“
  function platzVon(r) { return antworten.platzierung[schluessel(r)] || ''; }
  function lageVon(r) { return antworten.lage[schluessel(r)] || ''; }
  // Grundrissvarianten „Ja“ schließt Paket 1 aus: In der Beratungsstunde wird nur gesprochen, nichts gezeigt (Tobias 13.10.2026)
  function ohneBeratung(k) { return antworten.platzierung[k] === 'ja'; }
  function wunschErlaubt(id, k) { return !(id === 'gespraech' && ohneBeratung(k)); }
  function wunschVon(r) { var k = schluessel(r), w = antworten.wunsch[k] || ''; return wunschErlaubt(w, k) ? w : ''; }
  function frageRaeume() { return gemeinsam() ? [ALLE] : wohnraeume(); }
  // Seit 13.10.2026 entscheidet immer „Was würde Dir am meisten helfen?“ über das Paket (Situation ohne Wirkung)
  function unsicherWeg() { return hilfeFragen() && alleWunsch() && wohnraeume().some(function (r) { return wunschVon(r) === 'unsicher'; }); }
  // Empfehlungsseite überspringen: bei „unsicher“ und im individuellen Angebot nach den Fragen (Tobias 25.10.2026), direkt weiter zu den Zusatzfragen.
  // Neubau/Umbau und reines Büro behalten die Seite (dort kommen keine Fragen dazwischen).
  function alleWunsch() { return frageRaeume().every(function (k) { return !!antworten.wunsch[k] && wunschErlaubt(antworten.wunsch[k], k); }); }
  // Paket je Raum aus „Was würde Dir am meisten helfen?“; '' = unsicher → persönliche Empfehlung
  function paketVon(r) { return (WUNSCH.filter(function (x) { return x.id === wunschVon(r); })[0] || {}).paket || ''; }
  function grosseRaeume() { return wohnraeume().filter(function (r) { return antworten.groessen[r] === GROSSER_RAUM; }); }
  function sichtbareSchritte() {
    var leer = antworten.raeume.length === 0;
    return SCHRITTE.filter(function (s) {
      if (s === 'kueche') return !istNeubau() && kuecheRaeume().length > 0;
      if (s === 'groesse') return !istNeubau() && (wohnraeume().length > 0 || leer);
      if (s === 'platzierung' || s === 'lage' || s === 'wunsch') return leer || fragenZeigen();
      return true;
    });
  }

  // ================= Empfehlung =================
  function empfehlung() {
    var n = anzahlRaeume();
    var raumNamen = wohnraeume().map(raumLabel);
    var raumText = n + (n === 1 ? ' Raum' : ' Räume') + (raumNamen.length ? ' (' + raumNamen.join(', ') + ')' : '');
    var indiv = function (regel, grund, text) { return { art: 'individuell', regel: regel, grund: grund, orientierung: null, warum: [text] }; };
    if (istNeubau()) return indiv('R2', 'neubau', 'Bei Neubau, Umbau oder Renovierung planen wir individuell, damit Aufwand und Preis zu Deinem Vorhaben passen.');
    if (hat('buero')) return indiv('R1', 'gewerblich', 'Du planst Räume für Büro, Praxis oder Kanzlei. Dafür erstellen wir immer ein individuelles Angebot.');
    if (hat('kombi')) return indiv('R11', 'kombi', 'Für Deine Raumkombination stellen wir Dir ein passendes Angebot zusammen.');
    if (hat('anderes')) return indiv('R15', 'anderes', 'Für ' + (antworten.raumText.anderes ? '„' + antworten.raumText.anderes + '“' : 'Deinen Raum') + ' stellen wir Dir ein passendes Angebot zusammen.');
    if (kuecheRaeume().length) return indiv(kuecheAntwort('c') ? 'R12' : 'R16', 'kueche', kuecheAntwort('c')
      ? 'Du brauchst Unterstützung bei der konkreten Küchenplanung. Den Umfang schauen wir uns persönlich an und stellen Dir ein passendes Angebot zusammen.'
      : 'Bei einem Raum mit Küche planen wir alle Bereiche zusammen. Dafür stellen wir Dir ein individuelles Angebot zusammen.');
    if (hat('kueche') || hat('bad')) {
      var was = hat('kueche') && hat('bad') ? 'Küche und Bad' : (hat('kueche') ? 'die Küche' : 'das Bad');
      // Ein Satz statt zwei fast gleicher (Test 25.10.2026, A10); der allgemeine Küche/Bad-Hinweis wird hier nicht noch einmal angehängt
      var beide = hat('kueche') && hat('bad');
      return indiv('R14', 'kuechebad', 'Für ' + was + ' stellen wir Dir ein eigenes Angebot zusammen, weil Umfang und Abstimmung mit ' + (beide ? 'Küchenstudio und Sanitärbetrieb' : (hat('kueche') ? 'dem Küchenstudio' : 'dem Sanitärbetrieb')) + ' jedes Mal anders sind. Wir gestalten das Design und bereiten die Pläne so auf, dass ' + (beide ? 'beide direkt damit weiterarbeiten können.' : (hat('kueche') ? 'Dein Küchenstudio' : 'Dein Sanitärbetrieb') + ' direkt damit weiterarbeiten kann.'));
    }
    if (n >= AB_RAEUMEN_INDIVIDUELL) return indiv('R3', 'umfang', raumText + ': Bei so vielen Räumen lohnt es sich, gemeinsam draufzuschauen. Wir stellen Dir ein Gesamtangebot für Dein Projekt zusammen.');
    if (grosseRaeume().length) {
      var gr = grosseRaeume().map(raumLabel);
      return indiv('R4', 'umfang', (gr.length === 1 ? 'Dein ' + gr[0] + ' ist' : gr.join(' und ') + ' sind') + ' größer als 40 m². Große Räume planen wir individuell, damit Aufwand und Preis zu Deinem Projekt passen.');
    }
    if (wohnraeume().some(function (r) { return !paketVon(r); }))
      return { art: 'persoenlich', regel: 'R21', grund: 'unsicher', warum: ['Du bist Dir noch unsicher, was am besten passt. Wir schauen uns Dein Vorhaben persönlich an und empfehlen Dir, was Dir am meisten hilft.'] };
    var liste = wohnraeume().map(raumEmpfehlung);
    return { art: 'paket', raeume: liste,
      regel: liste.map(function (x) { return x.regel; }).filter(function (x, i, l) { return l.indexOf(x) === i; }).join(' + ') };
  }

  function raumEmpfehlung(id) {
    var paket = paketVon(id), basis = { id: id, paket: paket, regel: 'R20', alternative: null };
    if (paket === 'beratung') return Object.assign(basis, { variante: 'standard',
      warum: ['Du möchtest Fragen klären und Sicherheit bei Deinen Entscheidungen gewinnen, mit einem Profi an Deiner Seite'] });
    if (paket === 'styling') {
      return Object.assign(basis, { variante: 'bis7',
        warum: ['Du wünschst Dir konkrete Gestaltungsvorschläge für Deinen Raum'] });
    }
    return Object.assign(basis, { variante: 'ohne',
      warum: ['Du möchtest verschiedene Möglichkeiten ausprobieren und Dein Zuhause sehen, bevor Du etwas kaufst'] });
  }

  function kuecheBadHinweis(nurEinzeln) {
    // Kombinierte Räume nur, wenn eine neue Küche geplant ist (b/c), nicht bei vorhandener Küche oder „unsicher“ (Test 25.10.2026, A10)
    var k = hat('kueche') || (!nurEinzeln && KUECHE_RAEUME.some(function (r) { return hat(r) && /^[bc]$/.test(antworten.kueche[r] || ''); })), b = hat('bad');
    if (!k && !b) return '';
    var wer = k && b ? 'Küchenstudio und Dein Sanitärbetrieb' : (k ? 'Küchenstudio' : 'Sanitärbetrieb');
    var was = k && b ? 'Küche und Bad' : (k ? 'die Küche' : 'das Bad');
    return 'Für ' + was + ' gestalten wir das Design und bereiten die Pläne so auf, dass Dein ' + wer + ' direkt damit weiterarbeiten kann. Die technische Planung übernimmt der Fachbetrieb.';
  }

  // Option je Raum (Liste an/aus, bis/mehr als 7), im Ergebnis umstellbar
  function opt(rr) {
    if (rr.paket === 'concept' && istKuecheBad(rr.id)) return 'ohne';
    if (rr.paket === 'concept' && rr.variante === 'mit' && !variante('concept', preisstufe(rr.id), 'mit')) return 'ohne';
    return raumWahl[rr.id] && rr.paket !== 'beratung' ? raumWahl[rr.id] : rr.variante;
  }
  function raumVariante(rr) { return variante(rr.paket, preisstufe(rr.id), opt(rr)); }
  function raumPreis(rr) { var v = raumVariante(rr); return v ? v.price : 0; }
  function preis(e) { return e.raeume.reduce(function (s, rr) { return s + raumPreis(rr); }, 0); }
  function allePreise(e) { return e.raeume.every(function (rr) { return !!raumVariante(rr); }); }
  function pakete(e) { return ['beratung', 'styling', 'concept'].filter(function (k) { return e.raeume.some(function (rr) { return rr.paket === k; }); }); }
  function empfehlungKurz(e) {
    return e.art !== 'paket' ? e.art : e.raeume.map(function (rr) { return rr.id + ':' + rr.paket + (opt(rr) !== 'standard' ? ':' + opt(rr) : ''); }).join(',');
  }
  // Vorauswahl für die Produktseite (Format von si-paket.js)
  function produktLink(e, paket) {
    var ids = [], liste = [], mehr7 = [], option = '';
    e.raeume.forEach(function (rr) {
      if (rr.paket !== paket) return;
      ids.push(rr.id);
      if (paket === 'concept' && opt(rr) === 'mit') liste.push(rr.id);
      if (paket === 'styling' && !option) option = opt(rr);
      if (paket === 'styling' && opt(rr) === 'mehr7') mehr7.push(rr.id);
    });
    var q = 'raeume=' + ids.join(',') + (liste.length ? '&liste=' + liste.join(',') : '') + (option ? '&option=' + option : '') + (mehr7.length ? '&mehr7=' + mehr7.join(',') : '') + '&fys=' + fysId;
    return P[paket].url + (P[paket].url.indexOf('?') >= 0 ? '&' : '?') + q;
  }
  // Für das CRM: je Raum Paket, Option, Preis in Euro
  function empfehlungDaten(e) {
    var proRaum = function (x) { return x.raeume.map(function (rr) { return { raum: rr.id, label: raumLabel(rr.id), paket: rr.paket, option: opt(rr), preis: raumPreis(rr) / 100, regel: rr.regel }; }); };
    if (e.art === 'paket') return { art: 'paket', raeume: proRaum(e), preis: preis(e) / 100, regel: e.regel };
    return { art: e.art, grund: e.grund, regel: e.regel, orientierung: e.orientierung ? { raeume: proRaum(e.orientierung), preis: preis(e.orientierung) / 100 } : null };
  }
  // Antworten der Hilfe-Fragen je Raum ausgeschrieben, auch wenn sie für alle Räume gelten (fürs CRM)
  function antwortenJeRaum(feld) {
    var d = {};
    wohnraeume().forEach(function (r) { var v = antworten[feld][schluessel(r)]; if (v && (v.length || typeof v === 'string')) d[r] = v; });
    return d;
  }

  // ================= Tracking (GTM entscheidet nach Einwilligung) =================
  window.dataLayer = window.dataLayer || [];
  function track(name, params) {
    if (TEST) { testLog(name, params); return; }
    if (TEAM) { try { console.info('[FYS-Team] nicht gemessen: ' + name); } catch (e) {} return; }
    window.dataLayer.push(Object.assign({ event: name, form_name: 'find_your_service', form_version: FORM_VERSION, entry_point: einstieg || 'fys_seite' }, params || {}));
  }

  // Eigener Zähler (14.10.2026): meldet nur Schritt bzw. Ergebnis dieses Seitenaufrufs an das CRM,
  // ohne Antworten, ohne Cookie und ohne Speicher im Browser. Daraus entsteht der Wochenbericht (Starts, Abbrüche je Schritt).
  function zaehlen(schritt) {
    if (TEST) { testLog('zaehlen', schritt); return; }
    if (TEAM) return;
    if (!CFG.endpunkt) return;
    var d = JSON.stringify({ aktion: 'zaehlen', besuch: besuch, schritt: schritt, fassung: FORM_VERSION, einstieg: einstieg, fortgesetzt: fortgesetzt, gestartet: gestartet });
    // Als Text gesendet, damit der Browser keine Vorabfrage braucht; sendBeacon kommt auch beim Verlassen der Seite an
    try { if (navigator.sendBeacon && navigator.sendBeacon(CFG.endpunkt, d)) return; } catch (e) {}
    try { fetch(CFG.endpunkt, { method: 'POST', body: d, keepalive: true }).catch(function () {}); } catch (e) {}
  }

  // ================= Zwischenspeicher (nur dieser Tab) =================
  var SPEICHER = 'si_fys_' + (TEST ? 'test_' : '') + FORM_VERSION;
  function speichern() {
    if (!gestartet || abgeschickt) return;
    try { sessionStorage.setItem(SPEICHER, JSON.stringify({ antworten: antworten, aktuell: aktuell, fysId: fysId, wahl: wahl, termine: termine, auswahl: auswahl, raumWahl: raumWahl })); } catch (e) {}
  }
  function speicherLoeschen() { try { sessionStorage.removeItem(SPEICHER); } catch (e) {} }
  function speicherLaden() { try { return JSON.parse(sessionStorage.getItem(SPEICHER) || 'null'); } catch (e) { return null; } }

  // ================= Aufbau =================
  function raeumeBauen() {
    var box = $('raum-gruppen');
    // Geschäftlich und Anderes Vorhaben stehen nebeneinander mit Trennstrich, rosa abgesetzt (Feedback 12.10.2026)
    var NEBEN = ['gewerbe', 'bau'];
    var gruppeHtml = function (g) {
      return '<div class="raum-gruppe-box raum-gruppe-box--' + g[0] + '"><p class="raum-gruppe" id="fys-rg-' + g[0] + '">' + g[1] + '</p>' +
        '<div class="karten raum-karten" role="group" aria-labelledby="fys-rg-' + g[0] + '">' +
        RAEUME.filter(function (r) { return r.gruppe === g[0]; }).map(function (r) {
          return '<div class="karte si-wahl"><input type="checkbox" name="raeume" id="fys-r-' + r.id + '" value="' + r.id + '">' +
            '<label for="fys-r-' + r.id + '"><svg viewBox="0 0 40 40" aria-hidden="true">' + ICON[r.id] + '</svg>' + r.label + '</label>' + HAKEN + '</div>';
        }).join('') + '</div>' +
        RAEUME.filter(function (r) { return r.gruppe === g[0] && r.text; }).map(function (r) {
          return '<div class="feld raum-text" id="fys-rt-box-' + r.id + '" hidden><label for="fys-rt-' + r.id + '">' + r.text + ' <span class="optional">(optional)</span></label>' +
            '<input type="text" id="fys-rt-' + r.id + '" data-raumtext="' + r.id + '" maxlength="80" placeholder="' + esc(r.platz) + '"></div>';
        }).join('') + '</div>';
    };
    box.innerHTML = GRUPPEN.filter(function (g) { return NEBEN.indexOf(g[0]) < 0; }).map(gruppeHtml).join('') +
      '<div class="raum-gruppen-paar">' + GRUPPEN.filter(function (g) { return NEBEN.indexOf(g[0]) >= 0; }).map(gruppeHtml).join('') + '</div>';
    box.addEventListener('change', function (e) {
      var t = e.target;
      if (t.name !== 'raeume') return;
      // „Neubau, Umbau oder Renovierung“ steht für sich: wählt die anderen ab und umgekehrt
      if (t.checked && t.value === 'neubau') arr(box.querySelectorAll('input[name="raeume"]:checked')).forEach(function (i) { if (i !== t) i.checked = false; });
      if (t.checked && t.value !== 'neubau') { var nb = $('r-neubau'); if (nb) nb.checked = false; }
      raeumeUebernehmen();
    });
    box.addEventListener('input', function (e) {
      var r = e.target.getAttribute('data-raumtext');
      if (r) { antworten.raumText[r] = e.target.value.slice(0, 80); speichern(); }
    });
  }
  function raeumeUebernehmen() {
    var box = $('raum-gruppen');
    antworten.raeume = arr(box.querySelectorAll('input[name="raeume"]:checked')).map(function (i) { return i.value; });
    // Die gemeinsame Antwort (ALLE) bleibt; vorher fiel „Was würde Dir am meisten helfen?“ bei jeder Raumänderung weg (Test 25.10.2026, A8)
    ['kueche', 'groessen', 'wunsch', 'raumText'].forEach(function (feld) { Object.keys(antworten[feld]).forEach(function (r) { if (r !== ALLE && !hat(r)) delete antworten[feld][r]; }); });
    RAEUME.filter(function (r) { return r.text; }).forEach(function (r) {
      var b = $('rt-box-' + r.id); if (b) b.hidden = !hat(r.id);
      if (!hat(r.id)) $('rt-' + r.id).value = '';
    });
    var hinweis = kuecheBadHinweis(true); // kombinierte Räume mit Küche bekommen ihren Hinweis bei der Küchenfrage
    $('raum-hinweis').hidden = !hinweis;
    $('raum-hinweis').textContent = hinweis ? 'Gut zu wissen: ' + hinweis : '';
    beantwortet();
  }

  function groessenBauen() {
    var box = $('groessen'), raeume = wohnraeume();
    $('t-groesse').innerHTML = 'Wie <span class="hervor">groß</span> ' + (raeume.length === 1 ? 'ist Dein Raum' : 'sind Deine Räume') + ' ungefähr?';
    box.innerHTML = raeume.map(function (r) {
      return '<fieldset class="frageblock"><legend>' + (raeume.length === 1 ? '<span class="sr">' + esc(raumLabel(r)) + '</span>' : esc(raumLabel(r))) + '</legend><div class="chips">' +
        GROESSEN.map(function (g) {
          var id = 'fys-g-' + r + '-' + g[0];
          return '<span class="chip si-wahl"><input type="radio" name="g-' + r + '" id="' + id + '" value="' + g[0] + '"' + (antworten.groessen[r] === g[0] ? ' checked' : '') + '><label for="' + id + '">' + g[1] + '</label></span>';
        }).join('') + '</div></fieldset>';
    }).join('');
    box.onchange = function (e) {
      antworten.groessen[e.target.name.slice(2)] = e.target.value;
      beantwortet();
      if (gueltig('groesse')) autoWeiter();
    };
  }
  function timingBauen() {
    var liste = function (box, name, optionen, wert) {
      $(box).innerHTML = optionen.map(function (o) {
        var id = 'fys-' + name + '-' + o[0];
        return '<div class="option si-wahl"><input type="radio" name="' + name + '" id="' + id + '" value="' + o[0] + '"' + (wert === o[0] ? ' checked' : '') + '><label for="' + id + '"><span><b>' + o[1] + '</b></span>' + (o[0] === 'dringend' ? PUNKT : PFEIL) + '</label></div>';
      }).join('');
    };
    liste('start', 'start', START, antworten.start);
    $('f-dringend').value = antworten.dringendGrund;
    $('dringend-feld').hidden = antworten.start !== 'dringend';
  }
  function timingBinden() {
    var sek = root.querySelector('.schritt[data-schritt="timing"]');
    sek.addEventListener('change', function (e) {
      if (e.target.name !== 'start') return;
      antworten.start = e.target.value;
      var dringend = antworten.start === 'dringend';
      $('dringend-feld').hidden = !dringend;
      if (!dringend) { $('e-dringend').hidden = true; $('f-dringend').removeAttribute('aria-invalid'); }
      beantwortet();
      // „Dringend“: kein automatisches Weiter, erst den Grund eintragen. Per Pfeiltaste bleibt der Fokus in der Auswahl (A7).
      if (dringend) { if (!antworten.dringendGrund.trim() && !perPfeil) $('f-dringend').focus(); }
      else if (gueltig('timing')) autoWeiter();
    });
    $('f-dringend').addEventListener('input', function (e) {
      antworten.dringendGrund = e.target.value;
      e.target.removeAttribute('aria-invalid');
      $('e-dringend').hidden = true;
      beantwortet();
    });
  }

  function kuecheBauen() {
    var box = $('kueche'), raeume = kuecheRaeume(), mehrere = raeume.length > 1;
    box.innerHTML = raeume.map(function (r) {
      return '<fieldset class="raum-block' + (mehrere ? ' raum-karte' : '') + '"><legend' + (mehrere ? '' : ' class="sr"') + '>' + (mehrere ? '<span class="raum-pille">' + esc(raumLabel(r)) + '</span>' : esc(raumLabel(r))) + '</legend><div class="optionen">' +
        KUECHE.map(function (k) {
          var id = 'fys-k-' + r + '-' + k.id;
          return '<div class="option si-wahl"><input type="radio" name="k-' + r + '" id="' + id + '" value="' + k.id + '"' + (antworten.kueche[r] === k.id ? ' checked' : '') + '><label for="' + id + '">' +
            '<span><b>' + k.titel + '</b></span>' + PUNKT + '</label></div>';
        }).join('') + '</div></fieldset>';
    }).join('');
    // Hinweis zum Küchenstudio nur, wenn nicht die vorhandene Küche bleibt (Test 25.10.2026, A10); kein automatisches Weiter
    var hinweis = function () { $('kueche-hinweis').hidden = !raeume.some(function (r) { return !!antworten.kueche[r] && antworten.kueche[r] !== 'a'; }); };
    hinweis();
    box.onchange = function (e) {
      antworten.kueche[e.target.name.slice(2)] = e.target.value;
      hinweis();
      beantwortet();
    };
  }

  // Gemeinsame Bausteine für beide Hilfe-Fragen: einmal für alle Räume oder je Raum
  function frageBloecke(liste, typ, istGewaehlt) {
    var keys = frageRaeume(), mehrere = keys.length > 1;
    return keys.map(function (k) {
      return '<fieldset class="raum-block' + (mehrere ? ' raum-karte' : '') + '"><legend' + (mehrere ? '' : ' class="sr"') + '>' + (mehrere ? '<span class="raum-pille">' : '') + (k === ALLE ? 'Alle Räume' : esc(raumLabel(k))) + (mehrere ? '</span>' : '') + '</legend>' +
        liste.map(function (o) {
          var id = 'fys-' + typ + '-' + k + '-' + o.id;
          return '<div class="option si-wahl"><input type="' + (typ === 's' ? 'checkbox' : 'radio') + '" name="' + typ + '-' + k + '" id="' + id + '" value="' + o.id + '"' + (istGewaehlt(k, o.id) ? ' checked' : '') + '><label for="' + id + '">' +
            '<span><b>' + o.titel + '</b><span class="klein">' + o.klein + '</span></span>' + (typ === 's' ? KAESTCHEN : '<span class="pfeil" aria-hidden="true">→</span>') + '</label></div>';
        }).join('') + '</fieldset>';
    }).join('');
  }
  // Ein Schalter für Grundriss, Situation, Hilfe (Teil 1) und Situation (Teil 2); beim Abwählen gelten die Antworten für jeden Raum weiter
  function fuerAlleUmschalten(an) {
    antworten.fuerAlle = an;
    if (!an) wohnraeume().forEach(function (r) {
      ['platzierung', 'lage', 'wunsch'].forEach(function (f) { if (!antworten[f][r] && antworten[f][ALLE]) antworten[f][r] = antworten[f][ALLE]; });
    });
    track('fys_fuer_alle', { answer_option: an ? 'ja' : 'nein' });
  }
  function fuerAlleSchalter() {
    if (wohnraeume().length < 2) return '';
    return '<label class="fuer-alle"><input type="checkbox" id="fys-fuer-alle"' + (antworten.fuerAlle ? ' checked' : '') + '><span>Gilt für alle Räume</span>' +
      '<small>Abwählen, wenn Du die Fragen für jeden Raum einzeln beantworten möchtest.</small></label>';
  }
  function wunschBauen() {
    var box = $('wunsch'), keys = frageRaeume(), mehrere = keys.length > 1, verworfen = false;
    // Alte Antwort „Gespräch“ verwerfen, wenn inzwischen Grundrissvarianten gewünscht sind; dann mit Hinweis (A8)
    Object.keys(antworten.wunsch).forEach(function (k) { if (!wunschErlaubt(antworten.wunsch[k], k)) { delete antworten.wunsch[k]; verworfen = true; } });
    box.innerHTML = keys.map(function (k) {
      var karte = function (o) {
        var id = 'fys-w-' + k + '-' + o.id, an = antworten.wunsch[k] === o.id;
        return o.bild
          ? '<div class="bildwahl si-wahl"><input type="radio" name="w-' + k + '" id="' + id + '" value="' + o.id + '"' + (an ? ' checked' : '') + '><label for="' + id + '">' +
            '<span class="bildwahl-bild"><img src="' + o.bild + '" alt="" width="600" height="450" loading="lazy" decoding="async"></span>' +
            '<b>' + o.titel + '</b>' + (o.klein ? '<span class="klein">' + o.klein + '</span>' : '') + '</label>' + HAKEN + '</div>'
          : '<div class="option si-wahl' + (o.avatar ? ' option--avatar' : '') + '"><input type="radio" name="w-' + k + '" id="' + id + '" value="' + o.id + '"' + (an ? ' checked' : '') + '><label for="' + id + '">' +
            (o.avatar ? '<img class="avatar" src="' + esc(o.avatar) + '" alt="Sophia" width="56" height="56" loading="lazy" decoding="async">' : '') +
            '<span><b>' + o.titel + '</b><span class="klein">' + o.klein + '</span></span>' + (o.id === 'unsicher' ? PUNKT : PFEIL) + '</label></div>';
      };
      return '<fieldset class="raum-block' + (mehrere ? ' raum-karte' : '') + '"><legend' + (mehrere ? '' : ' class="sr"') + '>' + (mehrere ? '<span class="raum-pille">' : '') + (k === ALLE ? 'Alle Räume' : esc(raumLabel(k))) + (mehrere ? '</span>' : '') + '</legend>' +
        '<div class="bildwahlen' + (ohneBeratung(k) ? ' bildwahlen--zwei' : '') + '">' + WUNSCH.filter(function (o) { return o.bild && wunschErlaubt(o.id, k); }).map(karte).join('') + '</div>' +
        WUNSCH.filter(function (o) { return !o.bild; }).map(karte).join('') + '</fieldset>';
    }).join('') + fuerAlleSchalter();
    // Teilweise beantwortet (z. B. Raum dazugekommen) oder Antwort verworfen: sagen, was fehlt, statt still leer zu lassen
    var offen = keys.filter(function (k) { return !antworten.wunsch[k]; });
    if (offen.length && (verworfen || offen.length < keys.length)) setTimeout(function () {
      if (aktuell !== 'wunsch') return;
      var h = navHinweis();
      h.textContent = verworfen ? 'Weil Du Grundrissvarianten möchtest, passt der Video-Call allein nicht mehr. Bitte wähl hier neu.'
        : 'Für ' + offen.map(raumLabel).join(' und ') + ' fehlt hier noch eine Antwort.';
      h.dataset.art = 'gruppen';
      h.hidden = false;
      offen.forEach(function (k) { var i = box.querySelector('input[name="w-' + k + '"]'); var f = i && i.closest('fieldset'); if (f) f.classList.add('fehlt'); });
    }, 0);
    box.onchange = function (e) {
      if (e.target.id === 'fys-fuer-alle') { fuerAlleUmschalten(e.target.checked); wunschBauen(); beantwortet(); return; }
      antworten.wunsch[e.target.name.slice(2)] = e.target.value;
      beantwortet();
      // Bei „unsicher“ kein automatisches Weitergehen, sondern der Knopf „Weiter“ (Tobias 13.10.2026)
      if (gueltig('wunsch') && !unsicherWeg()) autoWeiter();
    };
  }

  // Einfachauswahl (Grundriss, Situation): für alle Räume oder je Raum, mit Schalter „Gilt für alle Räume“ (13.10.2026)
  function einfachBauen(feld, optionen) {
    var box = $(feld), keys = frageRaeume(), mehrere = keys.length > 1;
    box.innerHTML = keys.map(function (k) {
      return '<fieldset class="raum-block' + (mehrere ? ' raum-karte' : '') + '"><legend' + (mehrere ? '' : ' class="sr"') + '>' + (mehrere ? '<span class="raum-pille">' : '') + (k === ALLE ? 'Alle Räume' : esc(raumLabel(k))) + (mehrere ? '</span>' : '') + '</legend>' +
        optionen.map(function (o) {
          var id = 'fys-' + feld + '-' + k + '-' + o[0];
          return '<div class="option si-wahl"><input type="radio" name="' + feld + '-' + k + '" id="' + id + '" value="' + o[0] + '"' + (antworten[feld][k] === o[0] ? ' checked' : '') + '><label for="' + id + '"><span><b>' + o[1] + '</b>' + (o[2] ? '<span class="klein">' + o[2] + '</span>' : '') + '</span><span class="pfeil" aria-hidden="true">→</span></label></div>';
        }).join('') + '</fieldset>';
    }).join('') + fuerAlleSchalter();
    box.onchange = function (e) {
      if (e.target.id === 'fys-fuer-alle') { fuerAlleUmschalten(e.target.checked); einfachBauen(feld, optionen); beantwortet(); return; }
      antworten[feld][e.target.name.slice(feld.length + 1)] = e.target.value;
      beantwortet();
      if (gueltig(feld)) autoWeiter();
    };
  }



  function nachrichtBauen() {
    $('f-nachricht').addEventListener('input', function (e) {
      antworten.nachricht = e.target.value;
      if (e.target.value.trim()) { e.target.removeAttribute('aria-invalid'); var ne = $('e-nachricht'); if (ne) ne.hidden = true; }
      speichern(); knopfAktualisieren();
    });
  }

  // ================= Sprachnachricht: Aufnahme im Browser, Upload erst beim Absenden =================
  var MAX_SEK = 120, MIN_SEK = 1;
  var sprach = { blob: null, url: '', sek: 0, typ: '', pfad: '' };
  var aufnahme = null; // { rec, stream, start, timer, teile }
  var MIC = '<svg viewBox="0 0 24 24" aria-hidden="true"><rect x="9" y="3" width="6" height="11" rx="3"/><path d="M5 11a7 7 0 0 0 14 0M12 18v3"/></svg>';
  var STOPP = '<svg viewBox="0 0 24 24" aria-hidden="true"><rect x="7" y="7" width="10" height="10" rx="1.5"/></svg>';
  function kannAufnehmen() { return !!(navigator.mediaDevices && navigator.mediaDevices.getUserMedia && window.MediaRecorder); }
  function zeit(s) { s = Math.max(0, Math.round(s)); return Math.floor(s / 60) + ':' + ('0' + (s % 60)).slice(-2); }
  function audioTyp() {
    var l = ['audio/webm;codecs=opus', 'audio/webm', 'audio/mp4', 'audio/ogg;codecs=opus'];
    for (var i = 0; i < l.length; i++) { if (MediaRecorder.isTypeSupported && MediaRecorder.isTypeSupported(l[i])) return l[i]; }
    return '';
  }
  function sprachFehler(text) { var f = $('sprach-fehler'); f.hidden = !text; f.textContent = text || ''; }
  function sprachZeichnen() {
    var box = $('sprach-steuerung');
    if (aufnahme) {
      box.innerHTML = '<span class="sprach-punkt" aria-hidden="true"></span><span class="sprach-zeit" id="fys-sprach-zeit" role="timer">0:00 / ' + zeit(MAX_SEK) + '</span>' +
        '<button type="button" class="sprach-knopf sprach-knopf--stopp" id="fys-sprach-stopp">' + STOPP + 'Aufnahme beenden</button>';
      $('sprach-stopp').addEventListener('click', aufnahmeStoppen);
      $('sprach-stopp').focus();
    } else if (sprach.blob) {
      box.innerHTML = '<audio controls preload="metadata" src="' + sprach.url + '"></audio>' +
        '<span class="tipp-hinweis">Deine Sprachnachricht (' + zeit(sprach.sek) + ')</span>' +
        '<button type="button" class="sprach-klein" id="fys-sprach-neu">Neu aufnehmen</button>' +
        '<button type="button" class="sprach-klein" id="fys-sprach-weg">Löschen</button>';
      $('sprach-neu').addEventListener('click', function () { sprachLoeschen(); aufnahmeStarten(); });
      $('sprach-weg').addEventListener('click', function () { sprachLoeschen(); track('fys_voice_delete', {}); sprachZeichnen(); $('sprach-start').focus(); });
    } else {
      box.innerHTML = '<span class="sprach-frage">Überhaupt kein Bock auf Tippen?</span><button type="button" class="sprach-knopf" id="fys-sprach-start">' + MIC + 'Hinterlass uns eine Sprachnachricht</button>';
      $('sprach-start').addEventListener('click', aufnahmeStarten);
    }
    knopfAktualisieren();
  }
  function sprachLoeschen() {
    if (sprach.url) URL.revokeObjectURL(sprach.url);
    sprach = { blob: null, url: '', sek: 0, typ: '', pfad: '' };
  }
  function aufnahmeStarten() {
    sprachFehler('');
    navigator.mediaDevices.getUserMedia({ audio: { echoCancellation: true, noiseSuppression: true } }).then(function (stream) {
      var typ = audioTyp(), rec;
      try { rec = typ ? new MediaRecorder(stream, { mimeType: typ, audioBitsPerSecond: 64000 }) : new MediaRecorder(stream); }
      catch (e) { rec = new MediaRecorder(stream); }
      aufnahme = { rec: rec, stream: stream, start: Date.now(), teile: [], timer: null };
      rec.ondataavailable = function (ev) { if (ev.data && ev.data.size) aufnahme.teile.push(ev.data); };
      rec.onstop = aufnahmeFertig;
      rec.start(1000);
      aufnahme.timer = setInterval(function () {
        var s = (Date.now() - aufnahme.start) / 1000, el = $('sprach-zeit');
        if (el) el.textContent = zeit(s) + ' / ' + zeit(MAX_SEK);
        if (s >= MAX_SEK) aufnahmeStoppen();
      }, 250);
      track('fys_voice_start', {});
      sprachZeichnen();
    }).catch(function (err) {
      var name = err && err.name;
      sprachFehler(name === 'NotAllowedError' || name === 'SecurityError'
        ? 'Wir dürfen nicht aufs Mikrofon zugreifen. Du kannst es in den Einstellungen Deines Browsers erlauben oder uns einfach schreiben.'
        : 'Die Aufnahme hat nicht geklappt. Schreib uns gern stattdessen ein paar Zeilen.');
      track('fys_validation_error', { step_name: 'nachricht', error_type: 'mikrofon_' + (name || 'fehler') });
    });
  }
  function aufnahmeStoppen() {
    if (!aufnahme) return;
    clearInterval(aufnahme.timer);
    if (aufnahme.rec.state !== 'inactive') aufnahme.rec.stop();
  }
  function aufnahmeFertig() {
    var a = aufnahme;
    aufnahme = null;
    a.stream.getTracks().forEach(function (t) { t.stop(); });
    var sek = (Date.now() - a.start) / 1000;
    var typ = ((a.rec.mimeType || (a.teile[0] && a.teile[0].type) || 'audio/webm').split(';')[0]) || 'audio/webm';
    if (sek < MIN_SEK || !a.teile.length) { sprachFehler('Die Aufnahme war zu kurz. Versuch es gern noch einmal.'); sprachZeichnen(); return; }
    var blob = new Blob(a.teile, { type: typ });
    sprach = { blob: blob, url: URL.createObjectURL(blob), sek: Math.min(sek, MAX_SEK), typ: typ, pfad: '' };
    track('fys_voice_done', { duration_sec: Math.round(sprach.sek) });
    sprachZeichnen();
  }
  function sprachDatei() {
    var endung = { 'audio/mp4': 'm4a', 'audio/ogg': 'ogg', 'audio/mpeg': 'mp3', 'audio/aac': 'aac' }[sprach.typ] || 'webm';
    return new File([sprach.blob], 'sprachnachricht.' + endung, { type: sprach.typ });
  }
  function sprachBauen() {
    if (!kannAufnehmen()) return; // ohne Mikrofon-Schnittstelle bleibt nur das Textfeld
    $('sprach').hidden = false;
    sprachZeichnen();
  }

  function kontaktBauen() {
    ['vorname', 'nachname', 'email', 'plz'].forEach(function (f) {
      $('f-' + f).addEventListener('input', function (e) {
        antworten[f] = e.target.value;
        e.target.removeAttribute('aria-invalid');
        var err = $('e-' + f); if (err) err.hidden = true;
        speichern();
      });
    });
    var box = $('herkunft-chips');
    box.innerHTML = HERKUNFT.map(function (x, i) {
      return '<span class="chip si-wahl"><input type="radio" name="herkunft" id="fys-hk-' + i + '" value="' + x + '"><label for="fys-hk-' + i + '">' + x + '</label></span>';
    }).join('');
    box.addEventListener('change', function (e) {
      antworten.herkunft = e.target.value;
      $('e-herkunft').hidden = true;
      $('senden-fehler').hidden = true;
      speichern();
    });
  }

  // ================= Upload: verkleinern, Standortdaten weg, in den privaten Speicher =================
  var MAX_DATEIEN = 10, MAX_MB = 10;
  function post(daten) {
    if (TEST) { testLog('senden: ' + daten.aktion, daten); return new Promise(function (ok) { setTimeout(function () { ok({ ok: true }); }, 400); }); }
    return fetch(CFG.endpunkt, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(daten) })
      .then(function (res) {
        return res.json().catch(function () { return {}; }).then(function (j) {
          if (!res.ok || j.ok === false) { var f = new Error(j.fehler || 'Fehler ' + res.status); f.status = res.status; throw f; }
          return j;
        });
      });
  }
  // Fotos auf höchstens 2400 px verkleinern und als JPEG neu speichern: Dabei fallen Standort und andere Metadaten weg
  function vorbereiten(f) {
    if (!/^image\/(jpeg|png|webp)$/.test(f.type) || !window.createImageBitmap) return Promise.resolve(f);
    var notfall = new Promise(function (ok) { setTimeout(function () { ok(f); }, 8000); });
    return Promise.race([notfall, createImageBitmap(f).then(function (bild) {
      var s = Math.min(1, 2400 / Math.max(bild.width, bild.height));
      var c = document.createElement('canvas');
      c.width = Math.round(bild.width * s); c.height = Math.round(bild.height * s);
      var ctx = c.getContext('2d');
      ctx.fillStyle = '#fff'; ctx.fillRect(0, 0, c.width, c.height);
      ctx.drawImage(bild, 0, 0, c.width, c.height);
      return new Promise(function (ok) { c.toBlob(function (b) { ok(b || f); }, 'image/jpeg', 0.85); });
    }).then(function (b) {
      return b === f ? f : new File([b], f.name.replace(/\.[a-z0-9]+$/i, '') + '.jpg', { type: 'image/jpeg' });
    })]).catch(function () { return f; });
  }
  // Eine Datei über einen signierten Upload-Platz in den privaten Speicher; liefert den Pfad
  function hochladenDatei(f, fortschritt) {
    if (f.size > MAX_MB * 1024 * 1024) return Promise.reject(new Error('Zu groß (max. ' + MAX_MB + ' MB). Bitte eine kleinere Datei wählen.'));
    if (TEST) { testLog('hochladen (nicht gesendet)', f.name); if (fortschritt) fortschritt(1); return Promise.resolve('test/' + f.name); }
    return post({ aktion: 'upload', fys_id: fysId, name: f.name, typ: f.type || 'application/octet-stream', groesse: f.size }).then(function (slot) {
      return new Promise(function (ok, fehler) {
        var fd = new FormData();
        fd.append('cacheControl', '3600');
        fd.append('', f, f.name);
        var x = new XMLHttpRequest();
        x.open('PUT', slot.signedUrl);
        x.setRequestHeader('x-upsert', 'false');
        if (fortschritt) x.upload.onprogress = function (ev) { if (ev.lengthComputable) fortschritt(ev.loaded / ev.total); };
        x.onload = function () { if (x.status >= 200 && x.status < 300) ok(slot.path); else fehler(new Error('Hochladen fehlgeschlagen (' + x.status + ')')); };
        x.onerror = function () { fehler(new Error('Keine Verbindung')); };
        x.send(fd);
      });
    });
  }
  // Dateien werden beim Auswählen nur vorbereitet (verkleinert, Standortdaten weg) und erst beim Absenden hochgeladen
  function uploadBauen() {
    var zone = $('upload'), input = $('f-upload'), box = $('dateien');
    function verarbeiten(neu) {
      arr(neu).forEach(function (f) {
        var zeile = document.createElement('div');
        zeile.className = 'datei';
        var istBild = /^image\/(jpeg|png|webp|gif)$/.test(f.type);
        var vorschau = document.createElement(istBild ? 'img' : 'span');
        if (istBild) { vorschau.alt = ''; vorschau.src = URL.createObjectURL(f); } else { vorschau.className = 'datei-typ'; vorschau.textContent = f.type === 'application/pdf' ? 'PDF' : 'Bild'; vorschau.setAttribute('aria-hidden', 'true'); }
        zeile.appendChild(vorschau);
        zeile.insertAdjacentHTML('beforeend', '<div><b></b><span class="tipp-hinweis" role="status"></span> <button type="button" class="datei-weg">Entfernen</button></div>');
        zeile.querySelector('b').textContent = f.name;
        box.appendChild(zeile);
        var status = zeile.querySelector('.tipp-hinweis'), weg = zeile.querySelector('.datei-weg');
        weg.hidden = true;
        if (dateien.filter(function (d) { return d.status !== 'weg'; }).length >= MAX_DATEIEN - 1) { status.textContent = 'Höchstens ' + (MAX_DATEIEN - 1) + ' Dateien. Den Rest kannst Du uns nach dem Gespräch schicken.'; return; }
        if (!/^(image\/(jpeg|png|webp|heic|heif)|application\/pdf)$/.test(f.type)) { status.textContent = 'Dieses Format können wir nicht annehmen. Bitte JPG, PNG, HEIC oder PDF.'; return; }
        if (f.size > 25 * 1024 * 1024 || (!/^image\/(jpeg|png|webp)$/.test(f.type) && f.size > MAX_MB * 1024 * 1024)) {
          status.textContent = 'Zu groß (max. ' + MAX_MB + ' MB). Bitte eine kleinere Datei wählen.';
          track('fys_validation_error', { step_name: 'nachricht', error_type: 'file_too_large' });
          return;
        }
        var eintrag = { name: f.name, status: 'vorbereiten', zeile: zeile };
        dateien.push(eintrag);
        status.textContent = 'Wird vorbereitet …';
        sendenKnopf();
        vorbereiten(f).then(function (fertig) {
          if (eintrag.status === 'weg') return;
          if (fertig.size > MAX_MB * 1024 * 1024) { eintrag.status = 'weg'; status.textContent = 'Zu groß (max. ' + MAX_MB + ' MB). Bitte eine kleinere Datei wählen.'; return; }
          eintrag.datei = fertig;
          eintrag.status = 'bereit';
          status.textContent = (fertig !== f ? 'Verkleinert, Standortdaten entfernt. ' : '') + 'Wird mit Deiner Anfrage verschickt.';
          weg.hidden = false;
          track('fys_file_added', { file_type: fertig.type || 'unbekannt', file_count: dateien.filter(function (d) { return d.status === 'bereit'; }).length });
        }).then(sendenKnopf);
        weg.addEventListener('click', function () { eintrag.status = 'weg'; zeile.remove(); sendenKnopf(); });
      });
    }
    input.addEventListener('change', function () { verarbeiten(input.files); input.value = ''; });
    ['dragenter', 'dragover'].forEach(function (ev) { zone.addEventListener(ev, function (e) { e.preventDefault(); zone.classList.add('drueber'); }); });
    ['dragleave', 'drop'].forEach(function (ev) { zone.addEventListener(ev, function (e) { e.preventDefault(); zone.classList.remove('drueber'); }); });
    zone.addEventListener('drop', function (e) { if (e.dataTransfer) verarbeiten(e.dataTransfer.files); });
  }
  // Beim Absenden: alle bereiten Dateien nacheinander hochladen; Fehler halten die Anfrage nicht auf
  function alleHochladen(k) {
    var offen = dateien.filter(function (d) { return d.status === 'bereit' || d.status === 'fehler'; }), i = 0;
    function naechste() {
      if (i >= offen.length) return Promise.resolve();
      var d = offen[i++];
      k.textContent = 'Dateien werden hochgeladen (' + i + '/' + offen.length + ') …';
      return hochladenDatei(d.datei).then(function (pfad) { d.pfad = pfad; d.status = 'fertig'; track('fys_upload', { file_type: d.datei.type || 'unbekannt', file_count: i }); })
        .catch(function () { d.status = 'fehler'; track('fys_validation_error', { step_name: 'vorschlag', error_type: 'upload' }); })
        .then(naechste);
    }
    return naechste();
  }
  function sendenKnopf() {
    var laeuft = dateien.some(function (d) { return d.status === 'vorbereiten'; }), k = $('anfrage-senden');
    if (!k || k.dataset.sendet) return;
    k.disabled = laeuft;
    k.textContent = laeuft ? 'Dateien werden vorbereitet …' : WAHL_KNOPF[wahl] || 'Anfrage senden';
  }

  // ================= Ablauf =================
  function beantwortet() {
    if (!gestartet) { gestartet = true; track('fys_start', { path: antworten.weg || 'direkt' }); zaehlen(aktuell); }
    leisteAktualisieren();
    knopfAktualisieren();
    speichern();
  }

  function gueltig(s) {
    if (s === 'raeume') return antworten.raeume.length > 0;
    if (s === 'kueche') return kuecheRaeume().every(function (r) { return !!antworten.kueche[r]; });
    if (s === 'groesse') return wohnraeume().every(function (r) { return !!antworten.groessen[r]; });
    if (s === 'timing') return !!antworten.start && (antworten.start !== 'dringend' || !!antworten.dringendGrund.trim());
    if (s === 'wunsch') return wohnraeume().length > 0 && alleWunsch();
    if (s === 'platzierung') return frageRaeume().every(function (k) { return !!antworten.platzierung[k]; });
    if (s === 'lage') return frageRaeume().every(function (k) { return LAGE.some(function (o) { return o[0] === antworten.lage[k]; }); });
    // Pflicht seit 13.10.2026: Text oder Sprachnachricht (Fotos bleiben freiwillig)
    if (s === 'nachricht') return !aufnahme && (!!antworten.nachricht.trim() || !!sprach.blob);
    return true;
  }

  function knopfAktualisieren() {
    var l = sichtbareSchritte(), i = l.indexOf(aktuell), frage = i >= 0 && aktuell !== 'vorschlag', naechster = l[i + 1];
    $('nav').hidden = !frage;
    zurueckBtn.hidden = !frage || (i === 0 && !mitStart);
    // Kontakt: dort schickt „Empfehlung anfordern“ ab; Hilfe: Knopf erst, wenn jeder Raum eine Antwort hat (13.10.2026)
    weiterBtn.hidden = aktuell === 'wunsch' && !gueltig('wunsch');
    var zumVorschlag = naechster === 'vorschlag';
    weiterBtn.className = zumVorschlag ? 'btn-conversion' : 'weiter';
    weiterBtn.textContent = !zumVorschlag ? 'Weiter' : empfehlung().art === 'paket' ? 'Meine Empfehlung ansehen' : 'Zum Abschluss';
    // Nicht mehr „disabled“ (12.10.2026): Ein gesperrter Knopf ohne Erklärung wirkte tot, z. B. bei zwei Räumen,
    // wenn nur einer eine Größe hat. Jetzt bleibt er klickbar und sagt, was noch fehlt (fehltZeigen).
    var ok = gueltig(aktuell);
    // Seit 25.10.2026 (Test, A12) auch nicht mehr grau und ohne aria-disabled: Der Knopf ist immer aktiv
    weiterBtn.disabled = false;
    weiterBtn.removeAttribute('aria-disabled');
    weiterBtn.classList.remove('ist-gesperrt');
    fehltAufraeumen(ok);
  }

  // Hinweis unter dem Knopf; legt ihn an, falls die Section (noch) ohne das Element ausgeliefert wird
  function navHinweis() {
    var h = $('nav-hinweis');
    if (!h) { h = document.createElement('p'); h.className = 'nav-hinweis'; h.id = 'fys-nav-hinweis'; h.setAttribute('role', 'alert'); h.hidden = true; $('nav').appendChild(h); weiterBtn.setAttribute('aria-describedby', h.id); }
    return h;
  }
  // Offene Fragen im aktuellen Schritt: Radio-Gruppen ohne Auswahl
  function offeneGruppen() {
    var sek = document.querySelector('.si-fys .schritt[data-schritt="' + aktuell + '"]'), namen = [], gruppen = [];
    if (!sek) return gruppen;
    sek.querySelectorAll('input[type="radio"]').forEach(function (i) {
      if (namen.indexOf(i.name) >= 0 || i.offsetParent === null) return;
      namen.push(i.name);
      if (!sek.querySelector('input[type="radio"][name="' + i.name + '"]:checked')) gruppen.push(i);
    });
    return gruppen;
  }
  function fehltAufraeumen(ok) {
    var h = navHinweis();
    if (ok || (h.dataset.art === 'gruppen' && !offeneGruppen().length)) { h.hidden = true; h.textContent = ''; }
    document.querySelectorAll('.si-fys .fehlt').forEach(function (f) {
      var i = f.querySelector('input[type="radio"]');
      if (ok || (i && f.querySelector('input[name="' + i.name + '"]:checked'))) f.classList.remove('fehlt');
    });
  }
  function fehltZeigen() {
    var offen = offeneGruppen(), h = navHinweis(), text;
    h.dataset.art = '';
    offen.forEach(function (i) { var f = i.closest('fieldset') || i.closest('.frageblock'); if (f) f.classList.add('fehlt'); });
    if (aktuell === 'raeume') text = 'Bitte wähle mindestens einen Raum aus.';
    else if (aktuell === 'timing' && antworten.start === 'dringend') {
      // Nur die Meldung am Feld, nicht zusätzlich unter dem Knopf (Test 25.10.2026, A6)
      $('e-dringend').hidden = false; $('f-dringend').setAttribute('aria-invalid', 'true'); $('f-dringend').focus();
      h.hidden = true; h.textContent = '';
      track('fys_missing_answer', { step_name: aktuell, count: 0 });
      return;
    }
    else if (aktuell === 'nachricht') {
      text = aufnahme ? 'Bitte beende zuerst Deine Sprachaufnahme.' : 'Bitte schreib uns ein paar Worte oder hinterlass eine Sprachnachricht.';
      if (!aufnahme) {
        // Feld markieren und hinscrollen; der Hinweis steht zusätzlich direkt am Feld (Test 25.10.2026)
        var nf = $('f-nachricht'), ne = $('e-nachricht');
        if (!ne) { ne = document.createElement('span'); ne.className = 'fehler'; ne.id = 'fys-e-nachricht'; nf.parentNode.insertBefore(ne, nf.nextSibling); nf.setAttribute('aria-describedby', 'fys-e-nachricht fys-h-nachricht'); }
        ne.textContent = text; ne.hidden = false;
        nf.setAttribute('aria-invalid', 'true');
        nf.scrollIntoView({ behavior: reduziert() ? 'auto' : 'smooth', block: 'center' });
        nf.focus({ preventScroll: true });
      }
    }
    else if (aktuell === 'groesse' && offen.length) { text = 'Bitte wähle noch die Größe für ' + offen.map(function (i) { return raumLabel(i.name.slice(2)); }).join(' und ') + '.'; h.dataset.art = 'gruppen'; }
    else { text = offen.length > 1 ? 'Bitte beantworte noch die markierten Fragen.' : 'Bitte beantworte noch die markierte Frage.'; h.dataset.art = 'gruppen'; }
    h.textContent = text;
    h.hidden = false;
    track('fys_missing_answer', { step_name: aktuell, count: offen.length });
    if (offen[0]) { offen[0].focus({ preventScroll: true }); (offen[0].closest('fieldset') || offen[0]).scrollIntoView({ behavior: reduziert() ? 'auto' : 'smooth', block: 'center' }); }
  }

  var autoTimer = null;
  // Pfeiltasten wählen bei Radios schon aus: dann kein automatisches Weiter, bestätigt wird mit Enter oder „Weiter“ (Test 25.10.2026, A7, WCAG 3.2.2)
  var perPfeil = false;
  root.addEventListener('keydown', function (e) { perPfeil = /^Arrow/.test(e.key); }, true);
  root.addEventListener('pointerdown', function () { perPfeil = false; }, true);
  // 12.10.2026 (Tobias: „Ich fühle mich überrumpelt“): Auswahl erst 700 ms sichtbar lassen, dann den Schritt sanft ausblenden
  // und erst danach weiter. Vorher 420 ms und harter Wechsel. Neue Wahl in der Zwischenzeit startet die Wartezeit neu.
  function autoWeiter() {
    clearTimeout(autoTimer);
    var s = aktuell, el = root.querySelector('.schritt[data-schritt="' + s + '"]');
    if (el) el.classList.remove('raus');
    if (perPfeil) return;
    // Bewegung reduziert: gleiche Wartezeit, nur ohne Ausblenden (vorher 300 ms, also schneller)
    if (reduziert()) { autoTimer = setTimeout(function () { if (aktuell === s && gueltig(s)) weiter(); }, 940); return; }
    autoTimer = setTimeout(function () {
      if (aktuell !== s || !gueltig(s)) return;
      if (el) el.classList.add('raus');
      autoTimer = setTimeout(function () { if (el) el.classList.remove('raus'); if (aktuell === s && gueltig(s)) weiter(); }, 240);
    }, 700);
  }

  function nachOben() {
    var y = root.getBoundingClientRect().top + window.pageYOffset - 90;
    if (window.pageYOffset > y) window.scrollTo({ top: Math.max(0, y), behavior: reduziert() ? 'auto' : 'smooth' });
  }

  function schrittZeigen(ziel, richtung, ohneHistory) {
    var alt = root.querySelector('.schritt[data-schritt="' + aktuell + '"]');
    var neu = root.querySelector('.schritt[data-schritt="' + ziel + '"]');
    if (!neu) return;
    if (aufnahme && ziel !== 'nachricht') aufnahmeStoppen();
    videosSteuern(neu);
    if (ziel === 'kueche') kuecheBauen();
    if (ziel === 'groesse') groessenBauen();
    if (ziel === 'platzierung') einfachBauen('platzierung', PLATZIERUNG);
    if (ziel === 'lage') einfachBauen('lage', LAGE);
    if (ziel === 'wunsch') wunschBauen();
    if (ziel === 'timing') timingBauen();
    if (ziel === 'vorschlag') vorschlagZeigen();
    if (alt !== neu) {
      alt.hidden = true;
      neu.hidden = false;
      neu.classList.remove('rein', 'rein-zurueck');
      void neu.offsetWidth;
      neu.classList.add(richtung < 0 ? 'rein-zurueck' : 'rein');
    }
    aktuell = ziel;
    schrittSeit = Date.now();
    $('fortschritt').hidden = istInfo(ziel);
    leisteAktualisieren();
    knopfAktualisieren();
    var l = sichtbareSchritte(), idx = l.indexOf(ziel) + 1;
    setTimeout(function () { var t = neu.querySelector('.frage'); if (t) t.focus({ preventScroll: true }); }, 30);
    nachOben();
    zaehlen(ziel);
    if (!gesehen[ziel]) {
      gesehen[ziel] = true;
      track('fys_step_view', { step_index: idx, step_name: ziel, step_total: l.length });
    }
    if (!ohneHistory) { try { history.pushState({ fys: ziel }, ''); } catch (e) {} }
    speichern();
  }

  // Schrittleiste je Teil: Teil 1 bis zur Empfehlung, Teil 2 für die persönliche Empfehlung. Erledigte Schritte sind anklickbar.
  function leisteAktualisieren() {
    var l = sichtbareSchritte(), teil1 = TEIL1.indexOf(aktuell) >= 0;
    var punkte = l.filter(function (s) { return (TEIL1.indexOf(s) >= 0) === teil1; }), jetzt = punkte.indexOf(aktuell);
    var ol = $('schritte');
    ol.style.gridTemplateColumns = 'repeat(' + Math.max(punkte.length, 1) + ', minmax(0, 1fr))';
    // Ab 6 Schritten zeigt das Handy nur beim aktuellen Schritt den Namen, sonst die Nummer (11.10.2026)
    ol.classList.toggle('schritte--viele', punkte.length > 5);
    ol.innerHTML = punkte.map(function (s, i) {
      var fertig = i < jetzt;
      return '<li class="' + (s === aktuell ? 'aktiv' : (fertig ? 'fertig' : '')) + '"><button type="button" data-nr="' + (i + 1) + '" data-ziel="' + s + '"' + (fertig ? '' : ' disabled') + (s === aktuell ? ' aria-current="step"' : '') + '>' + LEISTE_NAME[s] + '</button></li>';
    }).join('');
    // Balken passt zur Leiste: gefüllt bis einschließlich des aktuellen Schritts (11.10.2026, vorher feste Prozentwerte)
    var wert = jetzt < 0 ? 0 : Math.round((jetzt + 1) / punkte.length * 100);
    $('balken').firstElementChild.style.transform = 'scaleX(' + (wert / 100) + ')';
    $('balken').setAttribute('aria-valuenow', wert);
  }

  function schrittErledigt() {
    var l = sichtbareSchritte();
    var p = { step_index: l.indexOf(aktuell) + 1, step_name: aktuell, time_on_step_sec: Math.min(600, Math.round((Date.now() - schrittSeit) / 1000)) };
    if (aktuell === 'raeume') p.answer_option = antworten.raeume.join(',');
    if (aktuell === 'kueche') p.answer_option = Object.keys(antworten.kueche).map(function (r) { return r + ':' + antworten.kueche[r]; }).join(',');
    if (aktuell === 'groesse') p.answer_option = wohnraeume().map(function (r) { return r + ':' + antworten.groessen[r]; }).join(',');
    if (aktuell === 'timing') p.answer_option = antworten.start;
    if (aktuell === 'wunsch') p.answer_option = Object.keys(antworten.wunsch).map(function (r) { return r + ':' + antworten.wunsch[r]; }).join(',');
    if (aktuell === 'platzierung') p.answer_option = Object.keys(antworten.platzierung).map(function (r) { return r + ':' + antworten.platzierung[r]; }).join(',');
    if (aktuell === 'lage') p.answer_option = Object.keys(antworten.lage).map(function (r) { return r + ':' + antworten.lage[r]; }).join(',');
    if (aktuell === 'nachricht') p.answer_option = (antworten.nachricht.trim() ? 'text' : '') + (sprach.blob ? '+sprache' : '') || 'leer';
    track('fys_step_complete', p);
  }

  function weiter() {
    if (!gueltig(aktuell)) return;
    schrittErledigt();
    var l = sichtbareSchritte(), naechster = l[l.indexOf(aktuell) + 1];
    if (!naechster) return;
    if (naechster === 'vorschlag') {
      raumWahl = {}; auswahl = {};
      var e = empfehlung();
      track('fys_complete', { recommendation: empfehlungKurz(e), room_count: anzahlRaeume(), value: e.art === 'paket' ? preis(e) / 100 : undefined, currency: e.art === 'paket' ? 'EUR' : undefined });
    }
    schrittZeigen(naechster, 1);
  }
  var letzteInfo = '';
  function zurueck() {
    if (aktuell.indexOf('thema-') === 0) return schrittZeigen('orientieren', -1, true);
    if (aktuell === 'orientieren') return schrittZeigen('start', -1, true);
    var l = sichtbareSchritte(), i = l.indexOf(aktuell);
    if (i < 0 || abgeschickt) return;
    if (i === 0) { if (mitStart) schrittZeigen(antworten.weg === 'b' ? (letzteInfo || 'orientieren') : 'start', -1, true); return; }
    track('fys_step_back', { step_index: i + 1, step_name: aktuell });
    schrittZeigen(l[i - 1], -1, true);
  }
  function wegWaehlen(weg) {
    // Wer sich erst orientiert hat und dann startet, bleibt als Weg „b“ gezählt
    if (weg === 'b' || antworten.weg !== 'b' || aktuell === 'start') antworten.weg = weg;
    if (istInfo(aktuell) && aktuell !== 'start') letzteInfo = aktuell;
    track('fys_path', { path: weg, step_name: aktuell });
    if (weg === 'b') return schrittZeigen('orientieren', 1);
    schrittZeigen('raeume', 1);
  }
  function themaZeigen(thema) {
    track('fys_topic', { topic: thema, step_name: aktuell });
    schrittZeigen('thema-' + thema, 1);
  }
  // Videos im Info-Teil laden erst, wenn ihr Abschnitt sichtbar wird; die anderen pausieren
  function videosSteuern(sichtbar) {
    arr(root.querySelectorAll('video[data-fys-video]')).forEach(function (v) {
      if (sichtbar.contains(v)) {
        if (reduziert()) { if (v.preload === 'none') { v.preload = 'metadata'; v.load(); } return; }
        v.preload = 'auto';
        var p = v.play(); if (p && p.catch) p.catch(function () {});
      } else if (!v.paused) v.pause();
    });
  }

  weiterBtn.addEventListener('click', function () { if (gueltig(aktuell)) weiter(); else fehltZeigen(); });
  zurueckBtn.addEventListener('click', zurueck);
  root.querySelectorAll('[data-info-zurueck]').forEach(function (b) { b.addEventListener('click', zurueck); });
  root.querySelectorAll('[data-weg]').forEach(function (b) { b.addEventListener('click', function () { wegWaehlen(b.getAttribute('data-weg')); }); });
  root.querySelectorAll('[data-thema]').forEach(function (b) { b.addEventListener('click', function () { themaZeigen(b.getAttribute('data-thema')); }); });
  $('schritte').addEventListener('click', function (e) {
    var b = e.target.closest('button[data-ziel]');
    if (!b || b.disabled) return;
    track('fys_step_jump', { step_name: b.getAttribute('data-ziel'), from_step: aktuell });
    schrittZeigen(b.getAttribute('data-ziel'), -1);
  });
  window.addEventListener('popstate', function (e) { if (e.state && e.state.fys) zurueck(); });
  $('form').addEventListener('submit', function (e) { e.preventDefault(); if (sichtbareSchritte().indexOf(aktuell) >= 0) weiter(); });
  root.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' && e.target.tagName !== 'TEXTAREA' && e.target.tagName !== 'BUTTON' && sichtbareSchritte().indexOf(aktuell) >= 0 && gueltig(aktuell)) { e.preventDefault(); weiter(); }
  });

  // ================= Ergebnis (Sophias Aufbau, 10.10.2026) =================
  // Kurztexte je Paket für die Empfehlungskarte
  var PAKET_TEXT = {
    beratung: { fuer: 'Für alle, die schon Ideen oder konkrete Fragen haben und Sicherheit von einem Profi möchten.', was: 'In einem persönlichen Video-Call klären wir Deine Fragen und geben Dir konkrete nächste Schritte mit.' },
    styling: { fuer: 'Für Räume, bei denen vieles bereits vorhanden ist, aber noch der gestalterische Feinschliff fehlt.', was: 'Mit einem individuellen 2D-Konzept und passenden Einrichtungsergänzungen zeigen wir Dir, wie Dein Raum zu einem stimmigen Ganzen wird.' },
    concept: { fuer: 'Für Räume, die grundlegend neu gedacht oder komplett eingerichtet werden sollen.', was: 'Mit Grundrissplanung und interaktiver 3D-Roomtour siehst Du Dein neues Zuhause, bevor Du etwas kaufst.' }
  };
  var auswahl = {};      // Raum → false, wenn abgewählt

  function paketBild(k) {
    if (!P[k] || !P[k].bild) return '';
    return '<img src="' + esc(P[k].bild) + '" alt="" width="600" height="400" loading="lazy" decoding="async">';
  }
  function warumHtml(l, grund) {
    l = l.slice();
    if (kuecheBadHinweis() && grund !== 'gewerblich' && grund !== 'neubau' && grund !== 'kuechebad') l.push(kuecheBadHinweis());
    return '<ul class="warum">' + l.map(function (w) { return '<li>' + esc(w) + '</li>'; }).join('') + '</ul>';
  }

  function gewaehlt(e) { return e.raeume.filter(function (rr) { return auswahl[rr.id] !== false; }); }

  // Zwischenergebnis nach Teil 1: Paket buchen oder weiter zur persönlichen Empfehlung per Mail
  // Aufbau seit 12.10.2026: Kopf mit Bild, Paketname als Überschrift, „Passt zu Dir, weil …“ und drei Fakten; darunter Räume, ein Preis, Buchen
  var FAKTEN = {
    beratung: ['Konkrete To-dos', 'Herstellerneutral', 'Video-Call mit Deiner Designerin'],
    styling: ['Ca. 7–14 Tage', 'Herstellerneutral', '2D-Visionboard + Shoppingliste'],
    concept: ['Ca. 7–14 Tage', 'Herstellerneutral', 'Grundriss + 3D-Roomtour']
  };
  // „Darum passt es zu Dir“: immer drei Häkchen, aus den eigenen Antworten abgeleitet (Tobias 13.10.2026)
  // 1. was Du uns erzählt hast (Situation/Wunsch), 2. was das Paket dafür tut (Grundriss, Menge, Shoppingliste), 3. was Du davon hast
  // rs = alle Räume dieses Pakets: Shoppingliste nur, wenn alle sie wollen; „viel Neues“, wenn einer es will
  function gruendeFuer(k, rs) {
    var r0 = rs.length ? rs[0].id : '', lage = r0 ? lageVon(r0) : '', pl = r0 ? platzVon(r0) : '', w = r0 ? wunschVon(r0) : '';
    var raum = rs.length > 1 ? 'Deine Räume' : 'Deinen Raum', dein = rs.length > 1 ? 'Deine Räume fühlen sich noch nicht ganz fertig an' : 'Dein Raum fühlt sich noch nicht ganz fertig an';
    if (k === 'beratung') return [
      lage === 'videocall' ? 'Dir reicht ein Video-Call, um Deine eigenen Ideen mit einem Profi zu besprechen'
        : lage === 'ergaenzen' ? 'Im Gespräch klären wir, welche Möbelstücke, Wandfarben und Deko Deinen Raum ergänzen'
        : lage === 'lost' ? 'Im Gespräch sortieren wir gemeinsam, wo Du am besten anfängst' : 'Du möchtest Deine Fragen persönlich mit einem Profi klären',
      pl === 'gemeinsam' ? 'Auch die Möbelplatzierung besprechen wir gemeinsam im Video-Call' : 'Im Video-Call bekommst Du ehrliches Feedback, bevor Du etwas kaufst oder umsetzt',
      'Du gehst mit konkreten nächsten Schritten raus, die Du selbst umsetzen kannst'
    ];
    if (k === 'styling') return [
      lage === 'videocall' ? 'Deine eigenen Ideen besprechen wir im Video-Call und machen daraus ein stimmiges Konzept'
        : lage === 'ergaenzen' ? 'Dir reichen ein paar ergänzende Möbelstücke und Empfehlungen zu Wandfarben und Deko'
        : lage === 'lost' ? 'Wir geben Dir einen klaren roten Faden für Möbel, Farben und Deko' : dein + ', Dir fehlt der letzte Schliff',
      'Wir ergänzen gezielt, was fehlt, und Dein Bestand bleibt die Grundlage',
      'Im Visionboard siehst Du vorab, wie alles zusammenpasst, und bestellst über die Shoppingliste'
    ];
    return [
      lage === 'lost' ? 'Wir planen ' + raum + ' von Grund auf, damit Du auf jeder Ebene Klarheit hast'
        : lage === 'videocall' ? 'Deine eigenen Ideen besprechen wir im Video-Call, daraus entsteht ein Gesamtkonzept'
        : lage === 'ergaenzen' ? 'Statt nur zu ergänzen, probieren wir verschiedene Möglichkeiten in 3D aus'
        : w === 'dreid' ? 'Du möchtest Möglichkeiten ausprobieren, statt nur Details zu ergänzen' : (rs.length > 1 ? 'Deine Räume sollen' : 'Dein Raum soll') + ' grundlegend neu gedacht werden',
      pl === 'ja' ? 'Du bekommst Grundrissvarianten, die zeigen, wo Deine Möbel am besten stehen' : 'Mit der Grundrissplanung finden wir die beste Aufteilung für ' + raum,
      'In der 3D-Roomtour siehst Du Dein neues Zuhause, bevor Du etwas kaufst'
    ];
  }
  function gruende(e, l) {
    if (l.length === 1) return gruendeFuer(l[0], e.raeume);
    // Mehrere Pakete: je Paket der erste Grund mit den Räumen davor, auf drei aufgefüllt
    var g = l.map(function (k) {
      var rs = e.raeume.filter(function (rr) { return rr.paket === k; });
      return rs.map(function (rr) { return raumLabel(rr.id); }).join(' und ') + ': ' + gruendeFuer(k, rs)[0];
    });
    return g.concat(['Jeder Raum bekommt genau so viel Planung, wie er braucht', 'Alles aus einer Hand, mit einem Stil, der zusammenpasst']).slice(0, 3);
  }
  function faktenHtml(l) {
    var f = l.length === 1 ? FAKTEN[l[0]] : (l.some(function (k) { return k !== 'beratung'; }) ? ['Ca. 7–14 Tage', 'Herstellerneutral'] : ['Herstellerneutral']);
    // „Herstellerneutral“ mit Erklärung beim Darüberfahren, sichtbar steht es kurz (Lydia, Review 11.10.2026 Nr. 10)
    return '<ul class="fakten">' + f.map(function (x) { return '<li' + (x === 'Herstellerneutral' ? ' title="Du kaufst, wo Du willst."' : '') + '>' + esc(x) + '</li>'; }).join('') + '</ul>';
  }
  function kopfSetzen(label, titel, bildPaket, intro) {
    $('vorschlag-label').textContent = label;
    // Paketname mit Lime-Markierung (dezenter Akzent auf heller Fläche, 12.10.2026)
    // Markierung: beim Paket der Name, sonst der in titel mit [[…]] gekennzeichnete Teil (12.10.2026: Markierung in jeder Überschrift)
    $('t-vorschlag').innerHTML = bildPaket ? '<span class="hervor">' + esc(titel) + '</span>' : esc(titel).replace(/\[\[(.+?)\]\]/, '<span class="hervor">$1</span>');
    var bild = $('ergebnis-bild');
    bild.innerHTML = bildPaket && P[bildPaket] && P[bildPaket].bild ? paketBild(bildPaket) : '';
    bild.hidden = !bild.innerHTML;
    $('ergebnis-kopf').classList.toggle('ergebnis-kopf--bild', !bild.hidden);
    $('empf-intro').innerHTML = intro;
  }
  function vorschlagZeigen() {
    var e = empfehlung(), karte = $('empfehlung');
    var ohnePaket = e.art !== 'paket' || !allePreise(e);
    if (ohnePaket) {
      var individuell = e.art === 'individuell';
      // Individuell (Review 11.10.2026 Nr. 6): kein „weit weg von unseren Standardpaketen“, das klang nach Absage
      // Kopf nur mit dem Grund; wie es weitergeht, steht darunter in „So geht es weiter“
      $('empf-gruende').innerHTML = '';
      kopfSetzen(individuell ? 'Unsere Einschätzung' : 'Unsere Empfehlung für Dich',
        individuell ? 'Dein Projekt bekommt ein [[eigenes Angebot]]' : 'Wir empfehlen Dir gern [[persönlich]], was passt', '',
        individuell ? warumHtml(e.warum || [], e.grund) : '<p class="empf-fuer">Du bist Dir noch unsicher, was am besten passt? Das ist völlig in Ordnung. Wir schauen uns Dein Vorhaben persönlich an.</p>');
      karte.innerHTML = e.grund === 'gewerblich' && CFG.gewerbeUrl ? '<p class="alternative"><a href="' + esc(CFG.gewerbeUrl) + '">Mehr zu Interior Design für Geschäftskund*innen</a></p>' : '';
      $('panel-buchen').innerHTML = '';
    } else {
      paketKarte(e);
    }
    $('ergebnis-karte').hidden = !karte.innerHTML;
    wahlZeigen(e, !ohnePaket);
    track('fys_consultation_view', { recommendation: empfehlungKurz(e) });
  }

  var preisNeu = false; // nach Umschalten: Preis kurz hervorheben
  function paketKarte(e) {
    var karte = $('empfehlung'), l = pakete(e), einPaket = l.length === 1, mehrere = e.raeume.length > 1;
    var sel = gewaehlt(e), selPakete = ['beratung', 'styling', 'concept'].filter(function (k) { return sel.some(function (rr) { return rr.paket === k; }); });
    // Begründung und Fakten unter dem Kopf über die volle Breite (13.10.2026), damit die Fakten in eine Zeile passen
    var warumBlock = '<p class="warum-titel">Darum passt es zu Dir</p><ul class="warum">' + gruende(e, l).map(function (w) { return '<li>' + esc(w) + '</li>'; }).join('') + '</ul>';
    if (!preisNeu) { // nach dem Umschalten bleibt der Kopf stehen
      kopfSetzen(einPaket ? PAKETE[l[0]].nr + ' · Unsere Empfehlung für Dich' : 'Unsere Empfehlung für Dich',
        einPaket ? PAKETE[l[0]].kurz : 'Für jeden Raum das passende Paket', einPaket ? l[0] : '',
        '<p class="empf-fuer">' + (einPaket ? PAKET_TEXT[l[0]].fuer : 'Wähle ab, was Du gerade nicht buchen möchtest.') + '</p>' +
        (einPaket ? '' : '<ul class="empf-pakete">' + l.map(function (k) { return '<li>' + (P[k].bild ? paketBild(k) : '') + '<span><b>' + PAKETE[k].nr + ' · ' + PAKETE[k].kurz + '</b>' + PAKET_TEXT[k].fuer + '</span></li>'; }).join('') + '</ul>'));
      $('empf-gruende').innerHTML = warumBlock + faktenHtml(l);
    }
    karte.innerHTML =
      '<ul class="positionen' + (mehrere ? '' : ' positionen--eins') + '">' + e.raeume.map(function (rr) {
        var t = preisstufe(rr.id), p = PAKETE[rr.paket], o = opt(rr), an = auswahl[rr.id] !== false;
        var zusatz = (einPaket ? '' : p.nr + ' · ' + p.kurz + ' · ') + TYP[t] + (rr.paket === 'beratung' ? ' · ' + STUNDEN[t] : '');
        var steuer = '';
        // „?“ wie auf den Produktseiten (si-paket.js), gleiche Texte (13.10.2026)
        var info = function (frage, titel, absaetze) { return '<details class="fys-info"><summary aria-label="' + esc(frage) + '">?</summary><div class="fys-info-panel"><b>' + esc(titel) + '</b>' + absaetze.map(function (x) { return '<p>' + x + '</p>'; }).join('') + '</div></details>'; };
        // Schalter: Aufpreis in Klammern direkt am Text; eingeschaltet „enthalten“, damit niemand ihn zum Preis addiert (Review 11.10.2026 Nr. 5)
        var aufpreis = function (diff, ist) { return ' <small>(' + (ist ? 'Aufpreis ' + euro(diff) + ' enthalten' : '+' + euro(diff)) + ')</small>'; };
        if (an && rr.paket === 'concept') {
          var mit = variante('concept', t, 'mit'), ohne = variante('concept', t, 'ohne');
          steuer = !mit || !ohne ? '' : '<label class="raum-sl"><input type="checkbox" class="sl-schalter" role="switch" id="fys-opt-' + rr.id + '" data-opt="' + rr.id + '" data-wert-an="mit" data-wert-aus="ohne"' + (o === 'mit' ? ' checked' : '') + '><span>' + LISTE_TEXT[t] + aufpreis(mit.price - ohne.price, o === 'mit') + '</span></label>' +
            info('Was ist die Shoppingliste?', 'Was ist die Shoppingliste?', ['Eine Liste aller Möbel und Accessoires aus Deinem Design, mit direkten Links zum Bestellen.', '<strong>Unsicher?</strong> Buch Dein Design erstmal ohne Shoppingliste. Du kannst sie nachträglich dazubuchen.']);
        } else if (an && rr.paket === 'styling') {
          // Schalter wie bei der Shoppingliste (11.10.2026): aus = bis 7, an = mehr als 7 neue Produkte
          var bis7 = variante('styling', t, 'bis7'), mehr7 = variante('styling', t, 'mehr7');
          steuer = !bis7 || !mehr7 ? '' : '<label class="raum-sl"><input type="checkbox" class="sl-schalter" role="switch" id="fys-opt-' + rr.id + '" data-opt="' + rr.id + '" data-wert-an="mehr7" data-wert-aus="bis7"' + (o === 'mehr7' ? ' checked' : '') + '><span>Mehr als 7 neue Produkte' + aufpreis(mehr7.price - bis7.price, o === 'mehr7') + '</span></label>' +
            info('Wann brauche ich mehr als 7 Neuprodukte?', 'Wie viele Neuprodukte brauchst Du?', ['<strong>Bis 7</strong> reicht, wenn die Basics stehen und nur das gewisse Etwas fehlt.', '<strong>Mehr als 7</strong> passt, wenn auch mehrere Möbel und Accessoires dazukommen sollen.', 'Unsicher? Starte mit bis 7, wir erweitern flexibel.']);
        }
        if (steuer) steuer = '<div class="raum-sl-zeile">' + steuer + '</div>';
        var schalter = mehrere ? '<input type="checkbox" class="raum-an" id="fys-an-' + rr.id + '" data-an="' + rr.id + '"' + (an ? ' checked' : '') + ' aria-label="' + esc(raumLabel(rr.id)) + ' buchen">' : '';
        // Ein Raum: Preis nur einmal, rechts in der Raumzeile (13.10.2026, vorher eigene Zeile „Preis“ direkt über dem Knopf)
        var preisB = mehrere ? '<b>' + euro(raumPreis(rr)) + '</b>' : '<b class="pos-preis' + (preisNeu ? ' preis-neu' : '') + '" aria-live="polite">' + euro(preis({ raeume: sel })) + '</b>';
        return '<li class="' + (an ? '' : 'ab') + (mehrere ? ' mit-schalter' : '') + '">' + schalter + '<label' + (mehrere ? ' for="fys-an-' + rr.id + '"' : '') + ' class="pos-name">' + esc(raumLabel(rr.id)) + '<small>' + zusatz + '</small></label>' + preisB + steuer + '</li>';
      }).join('') + '</ul>' +
      // Shoppingliste-Hinweis nur, wenn die Fakten sie nicht schon nennen
      (selPakete.indexOf('styling') >= 0 && !einPaket ? '<p class="fest">✓ Beim Styling Upgrade ist die Shoppingliste immer dabei</p>' : '') +
      (mehrere ? '<div class="gesamt"><span>Gesamt</span><b' + (preisNeu ? ' class="preis-neu"' : '') + ' aria-live="polite">' + euro(preis({ raeume: sel })) + '</b></div>' : '') +
      alternativenHtml(e);
    // Buchen sitzt seit 25.10.2026 im Weg „Jetzt buchen“
    $('panel-buchen').innerHTML = '<div class="buchen"><button type="button" class="btn-conversion" id="fys-buchen"' + (sel.length ? '' : ' disabled') + '>' + (selPakete.length > 1 || sel.length > 1 ? 'Ausgewählte Pakete buchen' : 'Dieses Paket direkt buchen') + ' →</button>' +
      selPakete.map(function (k) { return '<a class="link-klein" href="' + esc(produktLink(e, k)) + '" data-ansehen="' + k + '">Mehr zu ' + (selPakete.length === 1 ? 'diesem Paket' : PAKETE[k].nr + ' · ' + PAKETE[k].kurz) + ' ›</a>'; }).join('') +
      '<p class="hinweis-box" id="fys-buchen-hinweis" role="alert" hidden></p></div>';
    preisNeu = false;
    karte.querySelectorAll('[data-opt]').forEach(function (inp) {
      inp.addEventListener('change', function () {
        var r = inp.getAttribute('data-opt');
        raumWahl[r] = inp.getAttribute(inp.checked ? 'data-wert-an' : 'data-wert-aus');
        track('fys_option_change', { room: r, option: raumWahl[r] });
        speichern();
        preisNeu = true;
        paketKarte(e);
        var neu = document.getElementById(inp.id); if (neu) neu.focus();
      });
    });
    karte.querySelectorAll('[data-an]').forEach(function (inp) {
      inp.addEventListener('change', function () {
        var r = inp.getAttribute('data-an');
        auswahl[r] = inp.checked;
        speichern();
        track('fys_option_change', { room: r, option: inp.checked ? 'an' : 'ab' });
        preisNeu = true;
        paketKarte(e);
        var neu = document.getElementById(inp.id); if (neu) neu.focus();
      });
    });
    $('buchen').addEventListener('click', function () { inWarenkorb(e, this); });
    $('panel-buchen').querySelectorAll('[data-ansehen]').forEach(function (a) {
      a.addEventListener('click', function (ev) {
        track('fys_product_click', { package: a.getAttribute('data-ansehen') }); zaehlen('produktseite');
        // Antworten auch über die Paketseite mitgeben (30.10.2026): wird dort gebucht, kommen sie über die Kennung ins CRM
        if (ev.ctrlKey || ev.metaKey || ev.shiftKey || ev.button === 1 || a.target === '_blank') { kaufMerken(e, a); return; }
        ev.preventDefault();
        if (a.dataset.laeuft) return;
        a.dataset.laeuft = '1';
        var weiter = function () { location.href = a.href; };
        var notfall = setTimeout(weiter, 20000); // Netz klemmt: Paketseite trotzdem öffnen
        kaufMerken(e, a).then(function () { clearTimeout(notfall); weiter(); });
      });
    });
  }
  // Alternative nur, wenn sie ein anderes Paket nennt als empfohlen; höchstens eine Zeile je Paket
  function alternativenHtml(e) {
    var gesehenA = {}, l = pakete(e);
    return e.raeume.filter(function (rr) { return rr.alternative && l.indexOf(rr.alternative.paket) < 0; }).map(function (rr) {
      var a = rr.alternative;
      if (gesehenA[a.paket]) return '';
      gesehenA[a.paket] = true;
      return '<p class="alternative">Auch denkbar: <b>' + PAKETE[a.paket].name + '</b>, ' + a.text.charAt(0).toLowerCase() + a.text.slice(1) + '.</p>';
    }).join('');
  }

  // Vermerk am Warenkorb (Attribut „Find Your Service“): landet in der Bestellung und in der Team-Mail
  var vermerk = '';
  function heute() { return new Date().toLocaleDateString('de-DE', { day: '2-digit', month: '2-digit', year: 'numeric' }); }
  function warenkorbVermerk(text) {
    vermerk = text;
    if (TEST) { testLog('Warenkorb-Vermerk (nicht gesetzt)', text); return Promise.resolve(); }
    var basis = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return fetch(basis + 'cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ attributes: { 'Find Your Service': text.slice(0, 400) } }) }).catch(function () {});
  }
  function vermerkZusatz() {
    var z = [];
    if (antworten.start === 'dringend') z.push('Start: super dringend' + (antworten.dringendGrund.trim() ? ' (' + antworten.dringendGrund.trim().replace(/\s+/g, ' ') + ')' : ''));
    else if (antworten.start === '2wochen') z.push('Start: innerhalb von 2 Wochen');
    else if (antworten.start === 'spaeter') z.push('Start: später, flexibel');
    if (antworten.nachricht.trim()) z.push('Nachricht: ' + antworten.nachricht.trim().replace(/\s+/g, ' '));
    return z.length ? ' · ' + z.join(' · ') : '';
  }

  // Antworten für das CRM (Anfrage und Direktkauf gleich)
  function antwortenDaten() {
    return { weg: antworten.weg || (mitStart ? '' : 'direkt'), raeume: antworten.raeume, raum_text: antworten.raumText, kueche: antworten.kueche, groessen: antworten.groessen, platzierung: gemeinsam() ? antworten.platzierung[ALLE] || '' : '', lage: gemeinsam() ? antworten.lage[ALLE] || '' : '', platzierung_raum: gemeinsam() ? undefined : antwortenJeRaum('platzierung'), lage_raum: gemeinsam() ? undefined : antwortenJeRaum('lage'), start: antworten.start, start_grund: antworten.start === 'dringend' ? antworten.dringendGrund.trim() : undefined, fuer_alle: gemeinsam(), wunsch: antwortenJeRaum('wunsch') };
  }

  // Direkt buchen (30.10.2026): Fotos, Sprachnachricht und Antworten vorab ans CRM, ohne Kontaktdaten.
  // Übernommen werden sie erst, wenn die Shop-Bestellung mit derselben Kennung eintrifft. Scheitert etwas, wird trotzdem gebucht.
  function kaufMerken(e, knopf) {
    if (abgeschickt) return Promise.resolve(); // Antworten sind schon mit der Anfrage im CRM
    var text = knopf.textContent;
    return alleHochladen(knopf).then(function () {
      if (!sprach.blob || sprach.pfad) return;
      knopf.textContent = 'Sprachnachricht wird hochgeladen …';
      return hochladenDatei(sprachDatei()).then(function (pfad) { sprach.pfad = pfad; }).catch(function () {});
    }).then(function () {
      knopf.textContent = text;
      return post({
        aktion: 'kauf', fys_id: fysId, form_version: FORM_VERSION,
        wunsch: antworten.nachricht.trim(), sprachnachricht: sprach.pfad || undefined,
        antworten: antwortenDaten(), empfehlung: empfehlungDaten(e),
        dateien: dateien.filter(function (d) { return d.status === 'fertig'; }).map(function (d) { return d.pfad; }),
        source: quelle().source, gclid: quelle().gclid, einstieg: einstieg, seite: location.pathname, team: TEAM || undefined
      });
    }).catch(function () { knopf.textContent = text; });
  }

  // Eine Warenkorb-Zeile je Raum, wie auf den Produktseiten; danach zum Warenkorb
  function inWarenkorb(e, knopf) {
    e = { art: e.art, raeume: gewaehlt(e) };
    var items = e.raeume.map(function (rr) {
      var v = raumVariante(rr);
      return v ? { id: v.id, quantity: 1, properties: { 'Dein Raum': raumLabel(rr.id), _fys_id: fysId } } : null;
    }).filter(Boolean);
    if (!items.length) return;
    if (TEST) {
      testLog('in den Warenkorb (nicht gelegt)', items);
      var th = $('buchen-hinweis');
      th.hidden = false;
      th.textContent = 'Testmodus: Hier würden ' + items.length + ' Position(en) für ' + (preis(e) / 100).toLocaleString('de-DE') + ' € in den Warenkorb gelegt. Nichts wurde gebucht.';
      return;
    }
    knopf.disabled = true;
    knopf.classList.add('is-loading');
    track('add_to_cart', { currency: 'EUR', value: preis(e) / 100, items: e.raeume.map(function (rr) {
      return { item_id: rr.paket + ':' + opt(rr) + ':' + preisstufe(rr.id), item_name: PAKETE[rr.paket].name, item_variant: (OPTION_NAME[opt(rr)] ? OPTION_NAME[opt(rr)] + ' · ' : '') + TYP[preisstufe(rr.id)], quantity: 1, price: raumPreis(rr) / 100 };
    }) });
    var basis = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    // Vermerk erst setzen, wenn etwas im Warenkorb liegt: auf einem leeren Warenkorb ging er verloren (30.10.2026)
    var vermerkText = abgeschickt ? vermerk + ' · danach direkt gebucht' : 'Ausgefüllt am ' + heute() + ', direkt gebucht ohne Erstgespräch' + vermerkZusatz();
    kaufMerken(e, knopf)
      .then(function () { return fetch(basis + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: items }) }); })
      .then(function (res) { return res.json().then(function (j) { if (!res.ok) throw new Error(j.description || j.message || 'Fehler'); return j; }); })
      .then(function () { return warenkorbVermerk(vermerkText); })
      .then(function () { speicherLoeschen(); zaehlen('warenkorb'); location.href = basis + 'cart'; })
      .catch(function (err) {
        var h = $('buchen-hinweis');
        h.hidden = false;
        h.textContent = 'Das hat nicht geklappt: ' + err.message + ' Bitte versuch es noch einmal oder schreib uns an ' + (CFG.kontaktEmail || 'hallo@schoener-innen.com') + '.';
        knopf.disabled = false;
        knopf.classList.remove('is-loading');
      });
  }

  // ================= Abschluss: drei Wege (25.10.2026) =================
  // Buchen (nur mit Paket), Mehr Informationen per Mail, Kostenloses Erstgespräch mit Terminvorschlägen.
  // Der gewählte Weg klappt auf; die Kontaktfelder wandern in den Weg Mail bzw. Erstgespräch.
  var wahl = '';
  var WAHL_KNOPF = { email: 'Infos per Mail anfordern', erstgespraech: 'Erstgespräch anfragen' };
  function wahlZeigen(e, mitBuchen) {
    $('wahl-buchen-box').hidden = !mitBuchen;
    if (!mitBuchen && wahl === 'buchen') wahlSetzen('', true);
    $('wahl-titel').textContent = mitBuchen ? 'Wie möchtest Du weitermachen?' : 'Wie sollen wir uns bei Dir melden?';
    $('wahl-email-text').textContent = e.art === 'individuell'
      ? 'Wir schauen uns Dein Vorhaben an und schicken Dir innerhalb von 24 Stunden (werktags) unsere Einschätzung und ein passendes Angebot.'
      : 'Wir schauen uns Deine Antworten an und schicken Dir innerhalb von 24 Stunden (werktags) unsere persönliche Empfehlung.';
    if (wahl) wahlSetzen(wahl, true);
  }
  function wahlSetzen(w, still) {
    wahl = w;
    ['buchen', 'email', 'erstgespraech'].forEach(function (x) {
      var an = x === w;
      $('panel-' + x).hidden = !an;
      $('wahl-' + x).checked = an;
      $('panel-' + x).closest('.fys-weg').classList.toggle('ist-an', an);
    });
    var form = $('kontakt-form');
    if (w === 'email' || w === 'erstgespraech') {
      $('panel-' + w).appendChild(form);
      form.hidden = false;
      $('termin-block').hidden = w !== 'erstgespraech';
      if (w === 'erstgespraech') termineZeichnen();
      sendenKnopf();
    } else {
      form.hidden = true;
    }
    $('senden-fehler').hidden = true;
    speichern();
    // Wer die Wege per Pfeiltaste durchgeht, wählt jeden kurz an: nicht jeden als Auswahl zählen (Tracking)
    if (!still && w && !perPfeil) {
      var e = empfehlung();
      track('fys_option_select', { option: w, recommendation: empfehlungKurz(e) });
      if (w === 'email') track('fys_mail_path', { recommendation: empfehlungKurz(e) });
      if (w === 'erstgespraech') track('fys_consultation_click', { recommendation: empfehlungKurz(e) });
    }
  }
  function wahlBinden() {
    ['buchen', 'email', 'erstgespraech'].forEach(function (x) {
      $('wahl-' + x).addEventListener('change', function () { if (this.checked) wahlSetzen(x); });
    });
  }

  // Terminvorschläge fürs Erstgespräch: bis zu 5 Werktage (Mo–Fr, frühestens 3. Werktag),
  // je Tag Zeitfenster oder genaue Startzeit (9:00–18:30). Freiwillig.
  var ZEITFENSTER = [['vormittag', 'Vormittag', '9–12 Uhr'], ['mittag', 'Mittag', '12–14 Uhr'], ['nachmittag', 'Nachmittag', '14–17 Uhr'], ['spaet', 'Spätnachmittag', '17–19 Uhr'], ['genau', 'Genaue Uhrzeit', '']];
  var WERKTAGE_ANZEIGEN = 10, VORLAUF_WERKTAGE = 3, MAX_TAGE = 5;
  var STARTZEITEN = (function () { var l = []; for (var m = 9 * 60; m <= 18 * 60 + 30; m += 30) l.push(('0' + Math.floor(m / 60)).slice(-2) + ':' + ('0' + (m % 60)).slice(-2)); return l; })();
  function werktage() {
    var l = [], d = new Date(), gezaehlt = 0;
    d.setHours(12, 0, 0, 0);
    while (l.length < WERKTAGE_ANZEIGEN) {
      d.setDate(d.getDate() + 1);
      var wt = d.getDay();
      if (wt === 0 || wt === 6) continue;
      gezaehlt++;
      if (gezaehlt >= VORLAUF_WERKTAGE) l.push(d.getFullYear() + '-' + ('0' + (d.getMonth() + 1)).slice(-2) + '-' + ('0' + d.getDate()).slice(-2));
    }
    return l;
  }
  var TAGE = werktage(), termine = {}; // Datum → { zeit, uhrzeit }
  function datumText(iso) { return new Date(iso + 'T12:00:00').toLocaleDateString('de-DE', { weekday: 'short', day: '2-digit', month: '2-digit' }); }
  function termineGewaehlt() { return TAGE.filter(function (t) { return termine[t]; }); }
  function terminVollstaendig(t) { var v = termine[t]; return !!(v && v.zeit && (v.zeit !== 'genau' || v.uhrzeit)); }
  function termineGueltig() { return termineGewaehlt().filter(terminVollstaendig); }
  // Tage ohne Tageszeit/Uhrzeit: erst nach einem Absende-Versuch markiert (25.10.2026, Test: Tage fielen still weg)
  var terminFehlt = {};
  function termineUnvollstaendig() { return termineGewaehlt().filter(function (t) { return !terminVollstaendig(t); }); }
  function terminText(t, lang) {
    var v = termine[t];
    if (v.zeit === 'genau') return datumText(t) + ', ' + v.uhrzeit + ' Uhr';
    var z = ZEITFENSTER.filter(function (x) { return x[0] === v.zeit; })[0];
    return datumText(t) + ', ' + z[1] + (lang ? ' (' + z[2] + ')' : '');
  }
  function termineZeichnen() {
    var voll = termineGewaehlt().length >= MAX_TAGE;
    $('termin-tage').innerHTML = TAGE.map(function (t) {
      var id = 'fys-td-' + t, dd = new Date(t + 'T12:00:00'), an = !!termine[t];
      return '<span class="chip tag"><input type="checkbox" id="' + id + '" value="' + t + '"' + (an ? ' checked' : (voll ? ' disabled' : '')) + '><label for="' + id + '"><b>' +
        dd.toLocaleDateString('de-DE', { weekday: 'short' }).replace('.', '') + '</b>' + dd.toLocaleDateString('de-DE', { day: '2-digit', month: '2-digit' }) + '</label></span>';
    }).join('');
    $('termin-zeiten').innerHTML = termineGewaehlt().map(function (t) {
      var v = termine[t], k = t.replace(/-/g, '');
      var fenster = ZEITFENSTER.map(function (z) {
        var id = 'fys-tz-' + k + '-' + z[0];
        return '<span class="chip"><input type="radio" name="tz-' + k + '" id="' + id + '" value="' + z[0] + '" data-tag="' + t + '"' + (v.zeit === z[0] ? ' checked' : '') + '><label for="' + id + '">' + z[1] + (z[2] ? ' <small>' + z[2] + '</small>' : '') + '</label></span>';
      }).join('');
      var uhren = v.zeit === 'genau' ? '<div class="uhrzeiten" role="group" aria-label="Startzeit am ' + esc(datumText(t)) + '">' + STARTZEITEN.map(function (u) {
        var id = 'fys-tu-' + k + '-' + u.replace(':', '');
        return '<span class="chip"><input type="radio" name="tu-' + k + '" id="' + id + '" value="' + u + '" data-tag="' + t + '"' + (v.uhrzeit === u ? ' checked' : '') + '><label for="' + id + '">' + u + '</label></span>';
      }).join('') + '</div>' : '';
      var fehlt = terminFehlt[t] && !terminVollstaendig(t);
      return '<fieldset class="termin-zeile' + (fehlt ? ' fehlt' : '') + '" id="fys-tf-' + k + '"' + (fehlt ? ' aria-describedby="fys-te-' + k + '"' : '') + '><legend>' + esc(datumText(t)) + '</legend><div class="chips">' + fenster + '</div>' + uhren +
        (fehlt ? '<span class="fehler" id="fys-te-' + k + '">' + (v.zeit === 'genau' ? 'Bitte wähl noch eine Uhrzeit' : 'Bitte wähl noch eine Tageszeit') + ' – oder nimm den Tag oben wieder raus.</span>' : '') + '</fieldset>';
    }).join('');
  }
  function termineBinden() {
    $('termin-tage').addEventListener('change', function (ev) {
      var t = ev.target.value;
      if (ev.target.checked) termine[t] = termine[t] || { zeit: '', uhrzeit: '' };
      else { delete termine[t]; delete terminFehlt[t]; }
      termineZeichnen();
      speichern();
      var f = document.getElementById('fys-td-' + t); if (f) f.focus();
    });
    $('termin-zeiten').addEventListener('change', function (ev) {
      var inp = ev.target, t = inp.getAttribute('data-tag');
      if (!t || !termine[t]) return;
      if (inp.name.indexOf('tz-') === 0) {
        var vorher = termine[t].zeit;
        termine[t].zeit = inp.value;
        if (inp.value === 'genau' || vorher === 'genau') {
          termineZeichnen();
          var fokus = root.querySelector(inp.value === 'genau' && !perPfeil ? 'input[name="tu-' + t.replace(/-/g, '') + '"]' : '#' + inp.id);
          if (fokus) fokus.focus();
        }
      } else termine[t].uhrzeit = inp.value;
      speichern();
      // Fehlerhinweis am Tag verschwindet, sobald er vollständig ist
      if (terminFehlt[t] && terminVollstaendig(t)) { delete terminFehlt[t]; termineZeichnen(); var f2 = document.getElementById(inp.id); if (f2) f2.focus(); }
    });
  }

  function sendenFehler(k, err) {
    delete k.dataset.sendet;
    k.disabled = false;
    k.textContent = WAHL_KNOPF[wahl] || 'Anfrage senden';
    var s = $('senden-fehler');
    s.hidden = false;
    s.textContent = (err.status === 429 ? 'Gerade kommen zu viele Anfragen an. ' : 'Das hat leider nicht geklappt. ') +
      'Bitte versuch es gleich noch einmal oder schreib uns an ' + (CFG.kontaktEmail || 'hallo@schoener-innen.com') + '.';
    track('fys_validation_error', { step_name: 'vorschlag', error_type: 'senden' });
  }

  // Erst hier entstehen personenbezogene Daten. generate_lead erst nach erfolgreicher Antwort.
  function anfrageSenden() {
    var e = empfehlung(), fehler = [], k = $('anfrage-senden'), gespraech = wahl === 'erstgespraech';
    // Abgewählte Räume (Häkchen an der Empfehlung) gehen nicht mit (Test 25.10.2026); sind alle ab, gilt die ganze Empfehlung
    var gesendet = e.art === 'paket' && gewaehlt(e).length ? { art: e.art, raeume: gewaehlt(e), regel: e.regel } : e;
    if (wahl !== 'email' && !gespraech) return;
    $('senden-fehler').hidden = true;
    function f(id, falsch) { if (falsch) { $('f-' + id).setAttribute('aria-invalid', 'true'); $('e-' + id).hidden = false; fehler.push(id); } }
    f('vorname', !antworten.vorname.trim());
    f('nachname', !antworten.nachname.trim());
    f('email', !/^[^@\s]+@[^@\s]+\.[^@\s]{2,}$/.test(antworten.email.trim()));
    var plz = (antworten.plz || '').trim();
    f('plz', plz !== '' && !/^\d{4,5}$/.test(plz));
    if (!antworten.herkunft) { $('e-herkunft').hidden = false; fehler.push('herkunft'); }
    var offeneTage = gespraech ? termineUnvollstaendig() : [];
    if (offeneTage.length) { offeneTage.forEach(function (t) { terminFehlt[t] = true; }); termineZeichnen(); fehler.unshift('termin'); }
    if (fehler.length) {
      fehler.forEach(function (x) { track('fys_validation_error', { step_name: 'vorschlag', error_type: x }); });
      // Sammelhinweis direkt über dem Knopf, damit der Klick nicht wirkungslos wirkt (Test 25.10.2026)
      var s = $('senden-fehler');
      s.hidden = false;
      s.textContent = fehler.length === 1 && fehler[0] === 'herkunft' ? 'Fast geschafft: Bitte wähl noch aus, wo Du uns entdeckt hast.'
        : fehler.length === 1 && fehler[0] === 'termin' ? 'Bei ' + (offeneTage.length > 1 ? 'einigen Wunschtagen' : 'einem Wunschtag') + ' fehlt noch die Uhrzeit.'
        : 'Bitte ergänze noch die rot markierten Angaben.';
      var erstes = fehler[0] === 'termin' ? root.querySelector('#fys-tf-' + offeneTage[0].replace(/-/g, '') + ' input')
        : fehler[0] === 'herkunft' ? root.querySelector('#fys-herkunft-chips input') : $('f-' + fehler[0]);
      if (erstes) {
        (erstes.closest('fieldset') || erstes).scrollIntoView({ behavior: reduziert() ? 'auto' : 'smooth', block: 'center' });
        erstes.focus({ preventScroll: true });
      }
      return;
    }
    if (dateien.some(function (d) { return d.status === 'vorbereiten'; })) return;
    var gueltigeTermine = gespraech ? termineGueltig() : [];
    var terminDaten = gueltigeTermine.map(function (t) { var v = termine[t]; return v.zeit === 'genau' ? { datum: t, uhrzeit: v.uhrzeit } : { datum: t, zeitraum: v.zeit }; });
    k.disabled = true;
    k.dataset.sendet = '1';
    k.textContent = 'Wird gesendet …';

    // Erst Fotos/Grundrisse, dann die Sprachnachricht hochladen; scheitert etwas, geht die Anfrage trotzdem raus (Hinweis im Danke-Text)
    var hochladen = alleHochladen(k).then(function () {
      if (!sprach.blob || sprach.pfad) return;
      k.textContent = 'Sprachnachricht wird hochgeladen …';
      return hochladenDatei(sprachDatei()).then(function (pfad) { sprach.pfad = pfad; track('fys_upload', { file_type: sprach.typ, file_count: 1 }); })
        .catch(function () { track('fys_validation_error', { step_name: 'vorschlag', error_type: 'sprach_upload' }); });
    });

    hochladen.then(function () {
      k.textContent = 'Wird gesendet …';
      return post({
        aktion: 'anfrage', fys_id: fysId, form_version: FORM_VERSION, website: $('f-website').value,
        kontaktwunsch: gespraech ? 'erstgespraech' : 'email',
        kontakt: { vorname: antworten.vorname.trim(), nachname: antworten.nachname.trim(), email: antworten.email.trim(), plz: (antworten.plz || '').trim() || undefined },
        herkunft: antworten.herkunft, wunsch: antworten.nachricht.trim(), termine: terminDaten,
        sprachnachricht: sprach.pfad || undefined,
        antworten: antwortenDaten(),
        empfehlung: empfehlungDaten(gesendet),
        dateien: dateien.filter(function (d) { return d.status === 'fertig'; }).map(function (d) { return d.pfad; }),
        source: quelle().source, gclid: quelle().gclid, einstieg: einstieg, seite: location.pathname, team: TEAM || undefined
      });
    }).then(function () {
      abgeschickt = true;
      speicherLoeschen();
      zaehlen('anfrage');
      warenkorbVermerk((gespraech
        ? 'Erstgespräch angefragt am ' + heute() + (gueltigeTermine.length ? ' · Wunschzeiten: ' + gueltigeTermine.map(function (t) { return terminText(t); }).join(', ') : ' · ohne Terminvorschlag')
        : 'Persönliche Empfehlung angefordert am ' + heute()) + vermerkZusatz());
      track('generate_lead', { lead_type: e.art === 'individuell' ? 'fys_individuell' : gespraech ? 'fys_erstgespraech' : 'fys_email', contact_type: gespraech ? 'erstgespraech' : 'email', recommendation: empfehlungKurz(e),
        value: e.art === 'paket' ? preis(gesendet) / 100 : undefined, currency: e.art === 'paket' ? 'EUR' : undefined,
        voice_message: sprach.pfad ? 1 : 0, proposal_count: gueltigeTermine.length, transaction_id: fysId });
      $('ergebnis').hidden = true;
      $('fortschritt').hidden = true;
      var danke = $('anfrage-danke');
      danke.hidden = false;
      var mail = '<p class="termin-info">Eine Bestätigung ist schon unterwegs an <b>' + esc(antworten.email.trim()) + '</b>.</p>';
      var nachtrag = (dateien.some(function (d) { return d.status === 'fehler'; }) ? '<p class="termin-info">Einige Dateien konnten wir leider nicht mitschicken. Antworte einfach auf unsere Mail und häng sie an.</p>' : '') +
        (sprach.blob && !sprach.pfad ? '<p class="termin-info">Deine Sprachnachricht konnten wir leider nicht mitschicken. Antworte einfach auf unsere Mail, dann holen wir das nach.</p>' : '');
      danke.innerHTML = '<span class="danke-haken" aria-hidden="true"><svg viewBox="0 0 24 24"><path d="M6 12.5l4 4L18 8"/></svg></span>' +
        (gespraech
          ? '<p class="karte-label">Erstgespräch angefragt</p>' +
            '<p class="frage" tabindex="-1" id="fys-danke-titel">Danke, ' + esc(antworten.vorname.trim()) + '! Wir freuen uns auf <span class="hervor">das Gespräch</span>.</p>' +
            (gueltigeTermine.length
              ? '<p class="termin-info">Deine Wunschzeiten:</p><ul class="termin-liste">' + gueltigeTermine.map(function (t) { return '<li>' + esc(terminText(t, true)) + '</li>'; }).join('') + '</ul>' +
                '<p class="termin-info">Wir melden uns innerhalb von 24 Stunden (werktags) per Mail mit einem konkreten Terminvorschlag, möglichst zu einer Deiner Wunschzeiten, und dem Link zum Video-Call.</p>'
              : '<p class="termin-info">Wir schlagen Dir innerhalb von 24 Stunden (werktags) per Mail passende Termine vor.</p>')
          : '<p class="karte-label">Anfrage verschickt</p>' +
            '<p class="frage" tabindex="-1" id="fys-danke-titel">Danke, ' + esc(antworten.vorname.trim()) + '! Deine <span class="hervor">Anfrage ist da</span>.</p>' +
            '<p class="termin-info">' + (e.art === 'individuell'
              ? 'Wir schauen uns Dein Vorhaben an und melden uns innerhalb von 24 Stunden (werktags) per Mail mit unserer Einschätzung und den nächsten Schritten.'
              : 'Wir schauen uns Deine Antworten an und schicken Dir Deine persönliche Empfehlung innerhalb von 24 Stunden (werktags) per Mail.') + '</p>') +
        mail + nachtrag;
      $('danke-titel').focus();
      nachOben();
    }).catch(function (err) { sendenFehler(k, err); });
  }

  // ================= Start =================
  raeumeBauen(); timingBinden(); nachrichtBauen(); sprachBauen(); uploadBauen(); kontaktBauen();
  $('anfrage-senden').addEventListener('click', anfrageSenden);
  $('aendern').addEventListener('click', zurueck);
  wahlBinden(); termineBinden();

  var erster = mitStart ? 'start' : 'raeume';
  var alt = speicherLaden();
  if (alt && alt.antworten && alt.antworten.raeume && alt.antworten.raeume.length) {
    antworten = Object.assign(antworten, alt.antworten);
    // Gespeicherte Antworten von vor dem 13.10.2026: Grundriss und Situation waren ein einzelner Wert
    ['platzierung', 'lage'].forEach(function (f) { if (typeof antworten[f] === 'string') antworten[f] = antworten[f] ? { _alle: antworten[f] } : {}; });
    antworten.raeume = antworten.raeume.filter(function (r) { return !!raum(r); });
    if (alt.fysId && /^fys-[a-z0-9]{8,24}$/.test(alt.fysId)) fysId = alt.fysId;
    // Abschluss: gewählter Weg, Wunschzeiten (nur noch wählbare Tage, höchstens 5) und Raumauswahl (Test 25.10.2026, A11)
    if (['buchen', 'email', 'erstgespraech'].indexOf(alt.wahl) >= 0) wahl = alt.wahl;
    if (alt.termine && typeof alt.termine === 'object') TAGE.filter(function (t) { return alt.termine[t]; }).slice(0, MAX_TAGE).forEach(function (t) {
      var v = alt.termine[t] || {};
      termine[t] = { zeit: ZEITFENSTER.some(function (z) { return z[0] === v.zeit; }) ? v.zeit : '', uhrzeit: STARTZEITEN.indexOf(v.uhrzeit) >= 0 ? v.uhrzeit : '' };
    });
    if (alt.auswahl && typeof alt.auswahl === 'object') auswahl = alt.auswahl;
    if (alt.raumWahl && typeof alt.raumWahl === 'object') raumWahl = alt.raumWahl;
    gestartet = true;
    fortgesetzt = true;
    antworten.raeume.forEach(function (r) { var i = $('r-' + r); if (i) i.checked = true; });
    Object.keys(antworten.raumText || {}).forEach(function (r) { var i = $('rt-' + r); if (i) i.value = antworten.raumText[r]; });
    RAEUME.filter(function (r) { return r.text; }).forEach(function (r) { var b = $('rt-box-' + r.id); if (b) b.hidden = !hat(r.id); });
    ['vorname', 'nachname', 'email', 'plz'].forEach(function (f) { $('f-' + f).value = antworten[f] || ''; });
    $('f-nachricht').value = antworten.nachricht || '';
    if (antworten.herkunft) HERKUNFT.forEach(function (x, i) { if (x === antworten.herkunft) $('hk-' + i).checked = true; });
    $('fortsetzen').hidden = false;
    erster = alt.aktuell && alt.aktuell !== 'ergebnis' && !istInfo(alt.aktuell) && sichtbareSchritte().indexOf(alt.aktuell) >= 0 ? alt.aktuell : 'raeume';
  }
  $('neu-beginnen').addEventListener('click', function () { speicherLoeschen(); location.reload(); });

  // Startzustand: Im Markup ist „start“ sichtbar; bei direktem Einstieg oder Fortsetzen gleich weiter
  if (erster !== 'start') {
    root.querySelector('.schritt[data-schritt="start"]').hidden = true;
    root.querySelector('.schritt[data-schritt="' + erster + '"]').hidden = false;
    aktuell = erster;
    if (erster === 'kueche') kuecheBauen();
    if (erster === 'groesse') groessenBauen();
    if (erster === 'platzierung') einfachBauen('platzierung', PLATZIERUNG);
    if (erster === 'lage') einfachBauen('lage', LAGE);
    if (erster === 'wunsch') wunschBauen();
    if (erster === 'vorschlag') vorschlagZeigen();
    if (erster === 'timing') timingBauen();
    $('fortschritt').hidden = false;
  }
  try { history.replaceState({ fys: aktuell }, ''); } catch (e) {}
  track('fys_view', { path: mitStart ? 'start' : 'direkt' });
  zaehlen(aktuell);
  gesehen[aktuell] = true;
  track('fys_step_view', { step_index: Math.max(1, sichtbareSchritte().indexOf(aktuell) + 1), step_name: aktuell, step_total: sichtbareSchritte().length });
  leisteAktualisieren();
  knopfAktualisieren();
})();